// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:12:35.587Z
// Property: Woodland Pointe Residences (ID: 6767906449167503)
// Collections: 14 amenities, 8 floorplans (live), 18 photos, 82 POIs, 4 reviews, 3 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449167503",
  "property_external_id": "5669917",
  "property_zillow_url": "https://www.zillow.com/apartments/nashville-tn/hamptons-at-woodland-pointe/5XhxZw/",
  "property_apartments_url": "https://www.apartments.com/hamptons-at-woodland-pointe-nashville-tn/q1dwe5w/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Hamptons+at+Woodland+Pointe+Apartments/data=!4m2!3m1!1s0x0:0xe6b72e070a50124c?sa=X&ved=2ahUKEwiPgcm7k-eUAxWhnFYBHeVoM-UQ_BJ6BAg5EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54965251957",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": "5669917",
  "property_status": null,
  "property_slug": "woodland-pointe-residences",
  "property_name": "Woodland Pointe Residences",
  "property_website_url": "https://www.lifeatwoodland.com/",
  "property_domain": "https://www.lifeatwoodland.com/",
  "property_address": "1501 Woodland Pointe Dr",
  "property_full_address": "1501 Woodland Pointe Dr, Nashville, TN 37214",
  "property_address_1": "1501 Woodland Pointe Dr",
  "property_address_2": null,
  "property_address_city": "Nashville",
  "property_address_state": "TN",
  "property_address_zip_full": "37214-4702",
  "property_address_zip": "37214",
  "property_address_country": "US",
  "property_address_county": "Davidson County",
  "property_neighborhood_address": "Hermitage",
  "property_address_latitude": "36.1238999",
  "property_address_longitude": "-86.6286707",
  "property_email": "woodland@alapts.com",
  "property_phone": "6158722562",
  "property_call_tracking_phone": "615-894-0964",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Welcome home to Woodland Pointe Residences.</strong> Spacious 1, 2, and 3-bedroom apartments from 735 to 1,491 sq. ft. pair modern style with open living just minutes from Nashville. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p>Welcome home to Woodland Pointe Residences, where spacious 1, 2, and 3-bedroom apartment homes combine modern style, comfort, and convenience just minutes from Nashville, TN. Enjoy thoughtfully designed floor plans ranging from 735 to 1,491 sq. ft., featuring stylish finishes, open living spaces, and amenities designed to enhance your everyday lifestyle. Perfectly located near Nashville Airport, Percy Priest Lake, Nashville Shores Lakeside Resort, shopping, dining, and entertainment, Woodland Pointe Residences places everything you love within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01636-8b6c-7209-9e73-d3a40974f992.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
    "public_id": "01a01636-8b6c-7209-9e73-d3a40974f992",
    "storage_key": "property/6767906449167503/01a01636-8b6c-7209-9e73-d3a40974f992.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.66666666666666",
  "property_admin_fee": "75",
  "property_application_fee": "150",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9316655.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://woodlandpointeresidences.loftliving.com/login",
  "property_apply_now_url": "https://9316655.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8432-8c5e-775a-9fe1-fcac9536a74e.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodland Pointe Residences logo",
    "public_id": "019e8432-8c5e-775a-9fe1-fcac9536a74e",
    "storage_key": "property/6767906449167503/019e8432-8c5e-775a-9fe1-fcac9536a74e.webp",
    "width": 800,
    "height": 145
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8432-d130-71d4-a276-57239aee4f9c.webp",
  "property_icon_media": {
    "alt_text": "WP logo",
    "public_id": "019e8432-d130-71d4-a276-57239aee4f9c",
    "storage_key": "property/6767906449167503/019e8432-d130-71d4-a276-57239aee4f9c.webp",
    "width": 163,
    "height": 119
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8432-d130-71d4-a276-57239aee4f9c.webp",
  "property_fav_icon_media": {
    "alt_text": "WP logo",
    "public_id": "019e8432-d130-71d4-a276-57239aee4f9c",
    "storage_key": "property/6767906449167503/019e8432-d130-71d4-a276-57239aee4f9c.webp",
    "width": 163,
    "height": 119
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8430-f818-708f-826c-ec3b356f82e9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Woodland Pointe Residences logo",
    "public_id": "019e8430-f818-708f-826c-ec3b356f82e9",
    "storage_key": "property/6767906449167503/019e8430-f818-708f-826c-ec3b356f82e9.webp",
    "width": 800,
    "height": 146
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8430-f867-76fa-b1a7-78dc1fa9ad80.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Woodland Pointe Residences logo",
    "public_id": "019e8430-f867-76fa-b1a7-78dc1fa9ad80",
    "storage_key": "property/6767906449167503/019e8430-f867-76fa-b1a7-78dc1fa9ad80.webp",
    "width": 800,
    "height": 145
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#172138",
  "property_secondary_color": "#a85724",
  "property_font_color": null,
  "property_color_4": "#000000",
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "677 - 1491",
  "property_sqft_min": "677",
  "property_sqft_max": "1491",
  "property_price_range": "1490 - 2036",
  "property_price_min": "1490",
  "property_price_max": "2036",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/hamptonsatwoodlandpointe/",
  "property_instagram_url": "https://www.instagram.com/woodlandpointeresidences/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3QqjOnpsZIgRTBJQCgcut-Y",
  "property_youtube_url": "https://www.youtube.com/watch?v=WSL_mxaQN-E",
  "property_yelp_url": "https://www.yelp.com/biz/landmark-at-wynton-pointe-by-highmark-nashville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Woodland Pointe  Residences",
  "property_home_romance_title": "Experience the Joy of Living at Our Charming Community",
  "property_home_amenities_blurb": "<p><strong>Convenience meets room to unwind.</strong> At Woodland Pointe Residences, days flow easily with a refreshing pool and sundeck, fitness center, clubhouse lounge, business center, and coffee concierge.</p><p>Gated access, picnic and grilling areas, a car care center, and bark park add everyday ease, while apartment features like wood-inspired flooring, eat-in kitchens, walk-in closets, washer/dryer options, and select-home upgrades bring comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Nashville with open living areas, one- or two-bath designs, and thoughtful separation between bedrooms. Select homes add the extras that make a floor plan feel complete—walk-in closets, fireplaces, vaulted ceilings, balconies, garden-style views, stainless appliances, and in-home laundry or washer/dryer connections.</p>",
  "property_home_gallery_blurb": "<p><strong>See Woodland Pointe in focus.</strong> Preview sunlit interiors with wood-inspired floors, open living spaces, eat-in kitchens, and select finishes like stainless appliances, fireplaces, vaulted ceilings, or balcony views. Then picture the community backdrop: pool and sundeck, courtyard, grilling area, fitness center, clubhouse lounge, bark park, and car care center. Browse the gallery for a closer look at everyday life in Nashville.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lake days, local flavor, and Nashville access are all close by.</strong> Woodland Pointe Residences puts Percy Priest Lake recreation, Nashville Shores fun, and everyday favorites along Lebanon Pike within easy reach. Visit The Hermitage for a historic grounds-and-mansion outing, catch the weekday WeGo Star at Hermitage Station, or hop on I-40 for a simple trip into downtown Nashville. Explore the map to see what surrounds Woodland Pointe.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong><br>Woodland Pointe Residences earns high marks for its friendly office team, quick professional maintenance, clean quiet grounds, and welcoming feel. Reviews also highlight roomy, light-filled layouts, modern updates, attached garages in select homes, pet-friendly living, refreshed fitness spaces, community events, and a peaceful setting near the lake. See why Woodland Pointe is often described as feeling more like a home community than an apartment community.</p>",
  "property_neighborhood_blurb": "<p><strong>Put lake days, local flavor, and an easy Nashville connection on your map.</strong> From Woodland Pointe Residences in Hermitage, you’re close to Percy Priest Lake’s coves, trails, and shoreline recreation, with Nashville Shores adding waterpark fun, boat rentals, and zipline-style adventure nearby. Follow Lebanon Pike for neighborhood favorites like Nadeen’s Hermitage Haven and Steam Boys, or head toward The Hermitage for a historic mansion-and-grounds outing that feels distinctly east Nashville. When downtown calls, Hermitage Station on the WeGo Star offers a weekday rail option to Riverfront Station, while quick access to I-40 keeps shopping, dining, and entertainment trips simple. Explore the points around you on the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Woodland Pointe fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At Woodland Pointe Residences, everyday convenience meets space to unwind—from a refreshing pool and sundeck to a fitness center, clubhouse lounge, business center, and coffee concierge that make it easy to shift from work mode to downtime.</p><p>Outside, gated access, picnic and grilling areas, a courtyard, car care center, and a bark park add practical perks right where you live. Inside your apartment, enjoy comfort-focused details like wood-inspired flooring, eat-in kitchens, walk-in closets, washer/dryer options, and select-home upgrades such as stainless appliances, fireplaces, vaulted ceilings, garages, and private balconies or garden views. See how it all comes together in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Woodland Pointe Residences.</strong> Choose from spacious 1, 2, and 3-bedroom apartment homes with open layouts, stylish finishes, and everyday convenience minutes from Nashville. Find the floor plan that fits, then apply online with confidence.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Woodland Pointe Residences leasing team for help exploring spacious 1, 2, and 3-bedroom apartment homes near Nashville, TN. We’re here to make your next step simple, from floor plan details to finding your way to 1501 Woodland Pointe Dr.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Woodland Pointe Residences?</strong> Start here for helpful answers about our spacious 1, 2, and 3-bedroom apartment homes, leasing, community details, and everyday living near Nashville. If you need anything else, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find your fit, then picture the details.</strong> Woodland Pointe Residences offers one-, two-, and three-bedroom apartment layouts in Nashville with room to choose the setup that works for your day-to-day. Compare open living areas, one- or two-bath designs, generous bedroom separation, and options with features like eat-in kitchens, washer/dryer connections or in-home laundry, walk-in closets, fireplaces, vaulted ceilings, balconies, and garden-style views.</p><p>Use the floor plan cards below to check current pricing and availability, then pair your preferred layout with the finishes that matter most—from wood-inspired flooring to stainless appliances in select homes. Want a closer look before you decide? Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each space comes together.</p>",
  "property_gallery_blurb": "<p><strong>Let the gallery set the scene.</strong> Browse Woodland Pointe Residences through bright, real-life moments: wood-inspired floors catching the light, open living areas that flow into eat-in kitchens, and select homes with stainless appliances, fireplaces, vaulted ceilings, or a balcony view. Each photo helps you imagine how your routine could look here, from morning coffee at the breakfast bar to a quiet evening in a spacious one-, two-, or three-bedroom layout.</p><p>Then step outside the apartment. Picture afternoons by the pool and sundeck, fresh air in the courtyard, cookouts around the grilling area, and everyday convenience from the fitness center, clubhouse lounge, bark park, and car care center. Like what you see? Explore more <a href=\"/amenities\">community features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look in Nashville.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Woodland Pointe Residences on the map.</strong> See available 1, 2, and 3-bedroom <a href=\"/floor-plans\">apartment homes</a> and get a feel for the surrounding Nashville area, with shopping, dining, entertainment, and outdoor recreation all within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living feels effortless here.</strong> At Woodland Pointe Residences, your routine has space for tail wags, porch lounging, and quick outdoor breaks—whether you’re heading to the on-site bark park, taking a lap through the courtyard, or settling into a floor plan with room to spread out.</p><p>Back at home, everyday conveniences like in-home laundry options, wood-inspired flooring, large closets in select homes, and private balconies or garden-style views help make life with pets feel more manageable. When it’s time for a longer outing, Hermitage puts you near Metro dog parks and pet-care stops without pulling you far from home. Explore our <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see where your pet’s next routine could begin.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Woodland Pointe Residences.</strong> Invite friends to discover spacious 1, 2, and 3-bedroom apartment homes with modern style, open living spaces, and everyday convenience just minutes from Nashville. Send a referral today and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Woodland Pointe Residences</strong><br>Manage your everyday apartment needs with ease. Log in to pay rent, submit maintenance requests, and update your account—all from one convenient place at Woodland Pointe Residences, where modern comfort and convenience come together just minutes from Nashville.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents love about Woodland Pointe Residences.</strong><br>Review after review points to a community that feels cared for—from the friendly office team to maintenance requests handled quickly and professionally. Residents often call out the clean, quiet grounds, welcoming atmosphere, and apartment homes with roomy layouts, modern updates, light-filled spaces, and features like attached garages in select homes.</p><p>You’ll also see praise for everyday perks that make life easier: a renovated fitness center, well-kept shared spaces, pet-friendly living, community events, and a peaceful setting near the lake. As one resident put it, this feels like “more of a home community than an apartment community.” Browse the reviews below to see why so many choose to renew and recommend Woodland Pointe Residences.</p>",
  "property_created_at": "1779119410389",
  "property_scheduletour_blurb": "<p><strong>See Woodland Pointe Residences in person.</strong> Tour spacious 1, 2, and 3-bedroom apartment homes with open living spaces, stylish finishes, and floor plans ranging from 735 to 1,491 sq. ft. Discover the comfort and convenience waiting minutes from Nashville—then find the layout that feels right.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Woodland Pointe Residences.</strong><br>Your inquiry has been received, and our leasing team will follow up soon. We’re excited to share more about our spacious 1, 2, and 3-bedroom apartment homes, modern finishes, open living spaces, and convenient Nashville-area location.</p>",
  "property_virtualtours_blurb": "<p><strong>Click into the walkthroughs before you arrive.</strong> Explore Woodland Pointe Residences through immersive virtual tours that let you pause, turn, and take in the details at your own pace. Start with the community tour, then step inside a spacious 2-bedroom, 2-bath apartment to see the open living flow, wood-inspired flooring, bright windows, ceiling fans, and kitchen details like a peninsula layout and stainless appliance finishes in view.</p><p>Keep going with the Fitness Center tour for a look at cardio equipment, strength-training areas, mirrors, TVs, and natural light, then visit the Internet Cafe to picture a convenient work-or-browse stop close to home. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> in Nashville.</p>",
  "property_copyright": "2026 All Rights Reserved. Woodland Pointe  Residences",
  "property_seo_title_home": "Woodland Pointe  Residences |  Apartments in Nashville, TN",
  "property_seo_description_home": "Experience a blend of comfort and luxury at Woodland Pointe Residences in Nashville. With spacious layouts and outstanding amenities, your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Nashville, TN Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Woodland Pointe Residences in Nashville, TN. Choose from stylish one, two, or three-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Nashville, TN Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Woodland Pointe in Nashville! Enjoy a pet-friendly setting, modern amenities, and inviting spaces. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Nashville, TN",
  "property_seo_description_gallery": "Picture your life at Woodland Pointe in Nashville! Stunning photos highlight spacious floor plans, top-notch amenities, and a welcoming community vibe.",
  "property_seo_title_virtualtours": "Virtual Tours | Woodland Pointe  Residences Apartments",
  "property_seo_description_virtualtours": "Step inside Woodland Pointe Residences in Nashville, TN! Take a virtual tour of our charming one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Woodland Pointe  Residences Apartments",
  "property_seo_description_interactivemap": "Navigate your future at Woodland Pointe Residences in Nashville! Use our interactive map to find your ideal one, two, or three-bedroom apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Nashville, TN",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Woodland Pointe Residences in Nashville, TN. Dive into local favorites and exciting hotspots just steps away!",
  "property_seo_title_contact": "Contact Us | Woodland Pointe  Residences",
  "property_seo_description_contact": "Connect with Woodland Pointe Residences in Nashville, TN! Whether it's one, two, or three bedrooms, our leasing team is ready to answer your questions today.",
  "property_seo_title_faqs": "FAQs | Apartments in Nashville, TN",
  "property_seo_description_faqs": "Find answers to your questions at Woodland Pointe Residences in Nashville, TN. From amenities to pet policies, our FAQs have you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Nashville, TN",
  "property_seo_description_reviews": "Discover Woodland Pointe in Nashville! Enjoy spacious homes, great amenities, and a vibrant community that residents love.",
  "property_seo_title_applynow": "Apply Now | Apartments in Nashville, TN",
  "property_seo_description_applynow": "Experience modern living at Woodland Pointe Residences in Nashville, TN. Choose from one to three-bedroom layouts with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Woodland Pointe  Residences",
  "property_seo_description_residentaccess": "Experience convenience at Woodland Pointe Residences! Use the resident portal to pay rent, schedule maintenance, and manage community needs easily.",
  "property_seo_title_referafriend": "Refer A Friend | Woodland Pointe  Residences",
  "property_seo_description_referafriend": "Invite your friends to join the Woodland Pointe community in Nashville! Great friends make great neighbors—refer someone today and grow your circle!",
  "property_seo_title_scheduletour": "Schedule a Tour | Woodland Pointe  Residences",
  "property_seo_description_scheduletour": "Experience Woodland Pointe Residences in Nashville, TN. Schedule your tour today and find your perfect home in a vibrant community surrounded by nature!",
  "property_seo_title_privacy": "Privacy Policy | Woodland Pointe  Residences",
  "property_seo_description_privacy": "At Woodland Pointe Residences in Nashville, your privacy matters. Uncover how we protect your information while you enjoy modern living. Read our policy now.",
  "property_seo_title_accessibility": "Website Accessibility | Woodland Pointe  Residences",
  "property_seo_description_accessibility": "At Woodland Pointe Residences in Nashville, we prioritize digital inclusion. Our Accessibility Statement ensures everyone feels at home—both online and off!",
  "property_seo_title_sitemap": "Sitemap | Woodland Pointe  Residences",
  "property_seo_description_sitemap": "Uncover Woodland Pointe Residences in Nashville, TN, where modern living meets natural beauty. Check out our sitemap to navigate your new home effortlessly!",
  "property_seo_title_thankyou": "Thank You | Woodland Pointe  Residences",
  "property_seo_description_thankyou": "Thank you for reaching out to Woodland Pointe Residences! Our team will be in touch soon to help you find your perfect Nashville home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Nashville, TN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791249018968",
  "amenities": [
    {
      "id": "custom_08a549cf-83b8-471f-86a7-6125e53a144a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000002405",
      "title": "Resort Style Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool with Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5820f7da-ff7b-48ea-9fab-fac28847c8e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e3c0d02-d570-4597-a7b3-56569396dbf8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fitness Center with Free Weights",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f333707-492d-4980-ad11-314bbe497adf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Pavilion",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c036067-e8d4-48fa-8488-aacdc9ec6254",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000679",
      "title": "Smoke Free Community",
      "amount": "0.0000",
      "description": "Smoke Free Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a330daf5-2a45-4899-a312-f8887018d13d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Modern Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a131918a-f74c-47f4-ad9b-0cf171b93643",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbed2cc9-8ca7-4f25-baa8-2bfeb1f0e82e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8434be92-d9bf-42fc-bda3-ed58df2fbb78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "On-Site Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb2e1cfc-7f77-427c-81ca-79edbee077ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Concierge Cleaning Services Available by Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2b02d84-c1af-47aa-905d-b18732fc5a53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_035aa0eb-5edf-46d8-8823-4a3009fc85c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b658e199-38f6-4f77-ab22-51694c863218",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12dde550-b6a8-47db-94dc-3f1737c04bc5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "external_id": "P000000593",
      "title": "*Coming Soon",
      "amount": "0.0000",
      "description": "**Coming Soon",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_854db7d1-5c51-4498-bf17-efa8e3fb328f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-30a1-771b-abb4-3c8dd051f4c8.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with two built-in grills in a paved courtyard.",
        "public_id": "01a01637-30a1-771b-abb4-3c8dd051f4c8",
        "storage_key": "property/6767906449167503/01a01637-30a1-771b-abb4-3c8dd051f4c8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our outdoor grilling station, featuring two premium grills perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor kitchen with two built-in grills in a paved courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7be89aff-601a-4e50-9707-3fa5632b7333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-3106-733e-af8c-e74a9085cf3a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with parking lot and golf cart.",
        "public_id": "01a01637-3106-733e-af8c-e74a9085cf3a",
        "storage_key": "property/6767906449167503/01a01637-3106-733e-af8c-e74a9085cf3a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to our apartment community, featuring a well-maintained exterior with ample parking and a convenient golf cart for residents.",
      "link": "",
      "alt_text": "Exterior of apartment building with parking lot and golf cart.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fd00f0c-7237-4779-91b7-939c24ee87d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-3028-74d8-80ef-01b36b0858d1.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-unit apartment building with attached garages, lush green lawn, and mature trees.",
        "public_id": "01a01637-3028-74d8-80ef-01b36b0858d1",
        "storage_key": "property/6767906449167503/01a01637-3028-74d8-80ef-01b36b0858d1.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Charming exterior of our apartment building, featuring spacious residences with attached garages and beautiful landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multi-unit apartment building with attached garages, lush green lawn, and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e600c1d0-fab6-4565-8bfb-99c8a54cda9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1fd0-76cb-a7c7-b0ea555dc81f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a dining set under an umbrella.",
        "public_id": "01a01637-1fd0-76cb-a7c7-b0ea555dc81f",
        "storage_key": "property/6767906449167503/01a01637-1fd0-76cb-a7c7-b0ea555dc81f.webp",
        "width": 3072,
        "height": 2035
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a dining set under an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5182f87-219a-4b6c-b58b-5fe4ff3b0a04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-3039-7178-8c52-584e95c1e839.webp",
      "image_media": {
        "alt_text": "In-unit laundry area with washer and dryer, plus a built-in desk and shelving.",
        "public_id": "01a01637-3039-7178-8c52-584e95c1e839",
        "storage_key": "property/6767906449167503/01a01637-3039-7178-8c52-584e95c1e839.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit laundry room complete with a washer and dryer, ample shelving, and a built-in desk for added functionality.",
      "link": "",
      "alt_text": "In-unit laundry area with washer and dryer, plus a built-in desk and shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44a0e30e-6ce9-48d5-8d2b-8ef932a3db8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-2f7a-755f-b030-91bfc2ba995d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "01a01637-2f7a-755f-b030-91bfc2ba995d",
        "storage_key": "property/6767906449167503/01a01637-2f7a-755f-b030-91bfc2ba995d.webp",
        "width": 1675,
        "height": 939
      },
      "title": "Apartment",
      "description": "A bright and clean apartment bathroom featuring a modern vanity, a toilet, and a white bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46f8a816-e5fc-471c-a172-13087de9b49b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-2f8a-7558-8f63-a1c28623937e.webp",
      "image_media": {
        "alt_text": "Empty room with beige carpet and large bay windows",
        "public_id": "01a01637-2f8a-7558-8f63-a1c28623937e",
        "storage_key": "property/6767906449167503/01a01637-2f8a-7558-8f63-a1c28623937e.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious room with neutral paint, carpeting, and ample natural light from bay windows.",
      "link": "",
      "alt_text": "Empty room with beige carpet and large bay windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8cff9d63-ecfa-4f43-a43e-1011b9f73262",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-2e93-74c1-b371-e3a8ce0eb428.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit, chairs, and tables.",
        "public_id": "01a01637-2e93-74c1-b371-e3a8ce0eb428",
        "storage_key": "property/6767906449167503/01a01637-2e93-74c1-b371-e3a8ce0eb428.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating and a central fire pit, perfect for socializing.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit, chairs, and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a767cdfd-b15c-4edd-a340-2759aa405e71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1c3a-71d4-aade-c0d86c2554d0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample counter space, and an open view to the living area.",
        "public_id": "01a01637-1c3a-71d4-aade-c0d86c2554d0",
        "storage_key": "property/6767906449167503/01a01637-1c3a-71d4-aade-c0d86c2554d0.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen, featuring sleek stainless steel appliances, a spacious island perfect for casual dining, and an inviting open-concept layout flowing into the living space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, ample counter space, and an open view to the living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_442b4706-d71d-478d-abee-5b58960636fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1ac3-779b-9b20-8d12a2ab16e8.webp",
      "image_media": {
        "alt_text": "Empty living room with wood floors, windows overlooking greenery, and a ceiling fan.",
        "public_id": "01a01637-1ac3-779b-9b20-8d12a2ab16e8",
        "storage_key": "property/6767906449167503/01a01637-1ac3-779b-9b20-8d12a2ab16e8.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area with beautiful wood-look flooring, ample natural light from large windows, and a ceiling fan for comfort. Perfect for creating your own personalized oasis.",
      "link": "",
      "alt_text": "Empty living room with wood floors, windows overlooking greenery, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b275f91-a11d-4106-979b-951e3f73356a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1960-723e-98a5-3ef705519d50.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with attached garages on a sunny day.",
        "public_id": "01a01637-1960-723e-98a5-3ef705519d50",
        "storage_key": "property/6767906449167503/01a01637-1960-723e-98a5-3ef705519d50.webp",
        "width": 1693,
        "height": 929
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings featuring attached garages and well-maintained landscaping, offering a glimpse into the community's architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with attached garages on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8bd9cfab-d936-41c7-a099-f332278574c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1c51-7575-b16f-575f12ac3de4.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with shelf above.",
        "public_id": "01a01637-1c51-7575-b16f-575f12ac3de4",
        "storage_key": "property/6767906449167503/01a01637-1c51-7575-b16f-575f12ac3de4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with overhead shelving for storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with shelf above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38448e94-8a31-4946-a1cb-a6b1435026f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1988-7526-8691-d4642d26864f.webp",
      "image_media": {
        "alt_text": "Clubhouse seating area with sofas and a coffee table, overlooking the pool and courtyard.",
        "public_id": "01a01637-1988-7526-8691-d4642d26864f",
        "storage_key": "property/6767906449167503/01a01637-1988-7526-8691-d4642d26864f.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish clubhouse, featuring comfortable seating and stunning views of the pool and outdoor amenities.",
      "link": "",
      "alt_text": "Clubhouse seating area with sofas and a coffee table, overlooking the pool and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_86ec9cc4-ae2c-408b-9c2b-a320922fc450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1f0d-717a-bb08-e24ba62d8223.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and en-suite bathroom",
        "public_id": "01a01637-1f0d-717a-bb08-e24ba62d8223",
        "storage_key": "property/6767906449167503/01a01637-1f0d-717a-bb08-e24ba62d8223.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and a private en-suite bathroom with a bathtub and shower.",
      "link": "",
      "alt_text": "Bedroom with closet and en-suite bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1401dfb-ffa2-4298-95b4-9ba65af2f746",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1ac1-765a-8dc8-da42620d2cd1.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a ceiling fan.",
        "public_id": "01a01637-1ac1-765a-8dc8-da42620d2cd1",
        "storage_key": "property/6767906449167503/01a01637-1ac1-765a-8dc8-da42620d2cd1.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, a ceiling fan, and large windows that allow for natural light.",
      "link": "",
      "alt_text": "Living room with a fireplace and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c31fa08-4703-482f-ab0b-06938a8edcce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1b8e-7239-af7f-c9eb4728b5e5.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and dark countertops.",
        "public_id": "01a01637-1b8e-7239-af7f-c9eb4728b5e5",
        "storage_key": "property/6767906449167503/01a01637-1b8e-7239-af7f-c9eb4728b5e5.webp",
        "width": 1452,
        "height": 1083
      },
      "title": "Apartment",
      "description": "A bright and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant dark countertops.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, white cabinets, and dark countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d569122-8317-4198-97fe-7acbe2f686e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01637-1b81-77b5-b7b5-f35c6eea0d92.webp",
      "image_media": {
        "alt_text": "Row of treadmills in a gym",
        "public_id": "01a01637-1b81-77b5-b7b5-f35c6eea0d92",
        "storage_key": "property/6767906449167503/01a01637-1b81-77b5-b7b5-f35c6eea0d92.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "State-of-the-art treadmills available for residents to use in the community fitness center.",
      "link": "",
      "alt_text": "Row of treadmills in a gym",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8e519c1-666a-43a8-b03c-6b660f94c0cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01636-8b6c-7209-9e73-d3a40974f992.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
        "public_id": "01a01636-8b6c-7209-9e73-d3a40974f992",
        "storage_key": "property/6767906449167503/01a01636-8b6c-7209-9e73-d3a40974f992.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, perfect for relaxing and unwinding under the sun. Featuring comfortable lounge chairs and surrounded by lush landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_49a3286b2e6f21c2cf2b94bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Homegrown Taproom & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2720 Old Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Chill spot for locavore dining plus Sunday brunch with craft beers & ciders & growlers to-go.",
      "poi_long_description": "Chill spot for locavore dining plus Sunday brunch with craft beers & ciders & growlers to-go.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-ea66-732d-a8a8-eddc961dbe4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-ea66-732d-a8a8-eddc961dbe4a",
        "storage_key": "property/6767906449167503/019e3bd2-ea66-732d-a8a8-eddc961dbe4a.webp",
        "width": 1280,
        "height": 700
      },
      "poi_business_url": "https://homegrownnashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7891174025140040381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegrown-taproom--kitchen",
      "poi_latitude": "36.1702052",
      "poi_longitude": "-86.6657128",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 629-888-9180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-362b-779f-9246-f4a33713326c",
        "storage_key": "property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYVN0H5pZIgRvfJCdfcUg20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "ec_3d0ef23b7520a5f73fdc458a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Uncle Bud's Catfish Chicken & Such",
      "poi_type": "Restaurants",
      "poi_address": "2719 Old Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Familiar fixture with playful decor supplying all-you-can-eat catfish, chicken & Southern sides.",
      "poi_long_description": "Familiar fixture with playful decor supplying all-you-can-eat catfish, chicken & Southern sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-eb86-7372-99b3-487f6ac5f476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-eb86-7372-99b3-487f6ac5f476",
        "storage_key": "property/6767906449167503/019e3bd2-eb86-7372-99b3-487f6ac5f476.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://unclebuds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4593595942453297378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncle-buds-catfish-chicken--such",
      "poi_latitude": "36.1693369",
      "poi_longitude": "-86.6677247",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-678-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxy7kFXlpZIgR4sCa9yu7vz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_b8969d73fdfacb1538e11e36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Darfons Restaurant + Bar",
      "poi_type": "Restaurants",
      "poi_address": "2810 Elm Hill Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Casual, family-run eatery with pleasant decor & an American menu of classic meat & seafood dishes.",
      "poi_long_description": "Casual, family-run eatery with pleasant decor & an American menu of classic meat & seafood dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-d98d-746e-a848-7a8cc96423f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-d98d-746e-a848-7a8cc96423f6",
        "storage_key": "property/6767906449167503/019e3bc7-d98d-746e-a848-7a8cc96423f6.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.darfonsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4111325315517867543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "darfons-restaurant--bar",
      "poi_latitude": "36.1487998",
      "poi_longitude": "-86.6649322",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-889-3032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlY6Uil5pZIgRF2aDe5dcDjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_9a8a040815e517f3468f9bd0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nadeen's Hermitage Haven",
      "poi_type": "Restaurants",
      "poi_address": "3410 Lebanon Pike, Hermitage, TN 37076, USA",
      "poi_short_description": "Laid-back, rustic outpost for steak sandwiches, burgers, meatloaf & hot Tennessee chicken.",
      "poi_long_description": "Laid-back, rustic outpost for steak sandwiches, burgers, meatloaf & hot Tennessee chicken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-bc27-73bb-bf0a-d976aef2b97a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-bc27-73bb-bf0a-d976aef2b97a",
        "storage_key": "property/6767906449167503/019f14e1-bc27-73bb-bf0a-d976aef2b97a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nadeensinhermitage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1469384444365909444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nadeens-hermitage-haven",
      "poi_latitude": "36.1889867",
      "poi_longitude": "-86.628744",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-873-1184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-CKg1xqZIgRxC3q9F1NZBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ad2ef4fd534d32ac3c1b4bd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Papa Turney's Old Fashion BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3979 Bell Rd, Hermitage, TN 37076, USA",
      "poi_short_description": "Waterfront outpost with a deck featuring hickory-smoked BBQ plates & comfort grub in a casual space.",
      "poi_long_description": "Waterfront outpost with a deck featuring hickory-smoked BBQ plates & comfort grub in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-b961-7071-84d6-b6c3c094be5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-b961-7071-84d6-b6c3c094be5a",
        "storage_key": "property/6767906449167503/019f14e1-b961-7071-84d6-b6c3c094be5a.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "https://papaturneysbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12918350626081342159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papa-turneys-old-fashion-bbq",
      "poi_latitude": "36.1612091",
      "poi_longitude": "-86.60944359999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-866-8850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3L1eBBrZIgRzwKGN3MzR7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_dbafe025464778264501b1f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Shipwreck Cove",
      "poi_type": "Restaurants",
      "poi_address": "3361 Bell Rd, Nashville, TN 37214, USA",
      "poi_short_description": "Bar food, craft beers & signature cocktails on a wooden deck with live music, surrounded by yachts.",
      "poi_long_description": "Bar food, craft beers & signature cocktails on a wooden deck with live music, surrounded by yachts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-bec6-74bc-9774-e2e864bd41fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-bec6-74bc-9774-e2e864bd41fe",
        "storage_key": "property/6767906449167503/019f14e1-bec6-74bc-9774-e2e864bd41fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://shipwreckcovetn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=808838215632758777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shipwreck-cove",
      "poi_latitude": "36.13435279999999",
      "poi_longitude": "-86.6220658",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-872-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-362b-779f-9246-f4a33713326c",
        "storage_key": "property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA96rC4ZrZIgR-SeNWxKSOQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_e6d28221e65882b5683a5e20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Caney Fork River Valley Grille",
      "poi_type": "Restaurants",
      "poi_address": "2400 Music Valley Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Southern fried specialties & wild game dishes in a camping lodge environment with an indoor pond.",
      "poi_long_description": "Southern fried specialties & wild game dishes in a camping lodge environment with an indoor pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-ea40-73ce-a8d3-42befbc16d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-ea40-73ce-a8d3-42befbc16d42",
        "storage_key": "property/6767906449167503/019e3bd2-ea40-73ce-a8d3-42befbc16d42.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.caneyforkrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14216933566538689166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caney-fork-river-valley-grille",
      "poi_latitude": "36.2175844",
      "poi_longitude": "-86.69675459999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-724-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIei6-NVpZIgRjqrdFMGxTMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_b2889d09e139123216eccfe3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "514 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-f147-7266-87b3-5a30375c4ba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-f147-7266-87b3-5a30375c4ba2",
        "storage_key": "property/6767906449167503/019e3bd2-f147-7266-87b3-5a30375c4ba2.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-nashville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13600583771246626294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "36.2053258",
      "poi_longitude": "-86.6934066",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 629-278-5713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExz6FPNpZIgR9gUZh-H6vrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_19bd0ce4c38286c6baf00051",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "SweetMilk Breakfast & Lunch",
      "poi_type": "Restaurants",
      "poi_address": "329 Donelson Pike #201, Nashville, TN 37214, USA",
      "poi_short_description": "Casual restaurant serving breakfast, lunch, and brunch, along with coffee and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-8d4c-71c9-854e-3fea1f625155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-8d4c-71c9-854e-3fea1f625155",
        "storage_key": "property/6767906449167503/019eb778-8d4c-71c9-854e-3fea1f625155.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sweetmilkeats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9002199341774455380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetmilk-breakfast--lunch",
      "poi_latitude": "36.1568061",
      "poi_longitude": "-86.6644481",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY90z6i1pZIgRVMK4C5s87nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_048a44a1c29c052f84b690b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Bagelshop",
      "poi_type": "Restaurants",
      "poi_address": "2708 Old Lebanon Pike Ste 105, Nashville, TN 37214, USA",
      "poi_short_description": "Counter-serve spot for bagels, sandwiches and pizzas, along with coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-e726-77ec-bb66-46f4d30d5e02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-e726-77ec-bb66-46f4d30d5e02",
        "storage_key": "property/6767906449167503/019e3bd2-e726-77ec-bb66-46f4d30d5e02.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://bagelshopnashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17998428471532375896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bagelshop",
      "poi_latitude": "36.1699935",
      "poi_longitude": "-86.6684909",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-964-7820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzC6CZFpZIgRWM_2yFVDx_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_87fb9bc91afbaeb3e3fdbc3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Edley's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "2719 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "BBQ joint providing slow-smoked dishes & traditional Southern sides, plus fried chicken & catfish.",
      "poi_long_description": "BBQ joint providing slow-smoked dishes & traditional Southern sides, plus fried chicken & catfish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-de84-72f4-b789-e2ce8c5e4d50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-de84-72f4-b789-e2ce8c5e4d50",
        "storage_key": "property/6767906449167503/019e3bc7-de84-72f4-b789-e2ce8c5e4d50.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.edleysbbq.com/donelson",
      "poi_directions_map_url": "https://maps.google.com/?cid=8440790137876370204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edleys-bar-b-que",
      "poi_latitude": "36.1682185",
      "poi_longitude": "-86.6663528",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-331-3986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_a4v8JpZIgRHNO9v-i1I3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_2ea35d87bc8a2bf748e49e78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Roma Pizza & Pasta/ Sweets by Katie",
      "poi_type": "Restaurants",
      "poi_address": "504 Donelson Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Italian chain serving classic & creative pizzas, plus subs, wings & pasta, in a casual space.",
      "poi_long_description": "Italian chain serving classic & creative pizzas, plus subs, wings & pasta, in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-bec6-74bc-9774-ded46f969b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-bec6-74bc-9774-ded46f969b33",
        "storage_key": "property/6767906449167503/019f14e1-bec6-74bc-9774-ded46f969b33.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://romapizzaandpasta.com/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=9776499499996443207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roma-pizza--pasta-sweets-by-katie",
      "poi_latitude": "36.1502523",
      "poi_longitude": "-86.6668732",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-231-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyT3sr2NpZIgRR3ISRH8arYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_a633f4083b46ae8806a81c2c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Fox's Pizza Den",
      "poi_type": "Restaurants",
      "poi_address": "2828 Elm Hill Pike #108, Nashville, TN 37214, USA",
      "poi_short_description": "Laid-back chain serving specialty pizzas in varied sizes, plus sandwiches, salads & sides.",
      "poi_long_description": "Laid-back chain serving specialty pizzas in varied sizes, plus sandwiches, salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-bc27-73bb-bf0a-dd7234308845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-bc27-73bb-bf0a-dd7234308845",
        "storage_key": "property/6767906449167503/019f14e1-bc27-73bb-bf0a-dd7234308845.webp",
        "width": 821,
        "height": 1280
      },
      "poi_business_url": "https://foxspizzanashville.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10129754509232921319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foxs-pizza-den",
      "poi_latitude": "36.148716",
      "poi_longitude": "-86.663994",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-231-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Q3a-V5pZIgR51q9cA4elIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_5d54b5c0ed469ee019af9765",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Midnight Oil Donelson",
      "poi_type": "Restaurants",
      "poi_address": "2606 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-bf2a-7461-a7b0-bb8b87c88b4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-bf2a-7461-a7b0-bb8b87c88b4e",
        "storage_key": "property/6767906449167503/019f14e1-bf2a-7461-a7b0-bb8b87c88b4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://midnightoilpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6900682876193551932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midnight-oil-donelson",
      "poi_latitude": "36.170328",
      "poi_longitude": "-86.6748406",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-866-8292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7TzcARpZIgRPDYjt4MmxF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_f0a49f2845cd8a0a29e61996",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "143 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-f2e4-7439-879a-1a7f91c72690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-f2e4-7439-879a-1a7f91c72690",
        "storage_key": "property/6767906449167503/019e3bd2-f2e4-7439-879a-1a7f91c72690.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tn/nashville/mcgavock-pike/026/00845?cid=loc_02600845_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=51807572712204277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "36.1708586",
      "poi_longitude": "-86.6787306",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-883-0121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fef1-7787-81f1-98a07905a8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fef1-7787-81f1-98a07905a8d1",
        "storage_key": "property/6767906449167503/019e3bc7-fef1-7787-81f1-98a07905a8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01nR5XRpZIgR9acvgLYOuAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_6f5d4ffc65d2f9e692b05ec3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Publix Super Market at The Crossings",
      "poi_type": "Shopping & Retail",
      "poi_address": "2324 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-de33-702f-a44e-4326b8d7bffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-de33-702f-a44e-4326b8d7bffe",
        "storage_key": "property/6767906449167503/019e3bc7-de33-702f-a44e-4326b8d7bffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1426&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764234782777040188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-crossings",
      "poi_latitude": "36.1707831",
      "poi_longitude": "-86.68399869999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-884-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fef1-7787-81f1-98a07905a8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fef1-7787-81f1-98a07905a8d1",
        "storage_key": "property/6767906449167503/019e3bc7-fef1-7787-81f1-98a07905a8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUi8eAtpZIgRPF38_Ur2HUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_005d7740d4e5b847e502646a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c695-76b8-9a58-a613f141ce52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c695-76b8-9a58-a613f141ce52",
        "storage_key": "property/6767906449167503/019f14e1-c695-76b8-9a58-a613f141ce52.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.cvs.com/store-locator/nashville-tn-pharmacies/2500-lebanon-pike-nashville-tn-37214/storeid=6427?WT.mc_id=LS_GOOGLE_FS_6427",
      "poi_directions_map_url": "https://maps.google.com/?cid=17186356669125979677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.1699853",
      "poi_longitude": "-86.67927379999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-889-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYNj7XRpZIgRHW5rVlU0gu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_62ffe2e80d7d004321222b22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2421 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-9318-75e2-a7d2-b12dd9b9669e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-9318-75e2-a7d2-b12dd9b9669e",
        "storage_key": "property/6767906449167503/019eb778-9318-75e2-a7d2-b12dd9b9669e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2421+lebanon+pike-nashville-tn-37214/id=6853",
      "poi_directions_map_url": "https://maps.google.com/?cid=17900336444333904009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.1687363",
      "poi_longitude": "-86.68047130000001",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-885-4480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwDWpXRpZIgRiVCA9CfFavg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_5b11db0339a564a5e063ec4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3171 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c4ca-713d-aef3-e237fa73fbbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c4ca-713d-aef3-e237fa73fbbc",
        "storage_key": "property/6767906449167503/019f14e1-c4ca-713d-aef3-e237fa73fbbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/nashville-east/1059",
      "poi_directions_map_url": "https://maps.google.com/?cid=10532085153208130762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.18256",
      "poi_longitude": "-86.63778599999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-889-4734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl0zjmkhqZIgRytwiPaV7KZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d46bb625823675a4dad9ec18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Opry Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "433 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_long_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c17e-759c-9865-04cc14e19eea",
        "storage_key": "property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.simon.com/mall/opry-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=13159961003414719041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "opry-mills",
      "poi_latitude": "36.2048497",
      "poi_longitude": "-86.6930726",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-514-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgz_abddpZIgRQQqH4s6SobY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ea5a291347226a373acd9ca7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2330 Jackson Downs Blvd, Nashville, TN 37214, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-f995-772e-8d2d-5c26de9789b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-f995-772e-8d2d-5c26de9789b8",
        "storage_key": "property/6767906449167503/019e3bd2-f995-772e-8d2d-5c26de9789b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/tn/nashville-523.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040492022022871415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "36.1835752",
      "poi_longitude": "-86.63480009999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-885-1378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD-q49EVqZIgRdxlBeX0j1FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_f3ac65ed73d9dfb4d5c3547d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "2710 Old Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-ca84-763a-a826-53265bbc4a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-ca84-763a-a826-53265bbc4a43",
        "storage_key": "property/6767906449167503/019f14e1-ca84-763a-a826-53265bbc4a43.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=532992419608194587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-plaza",
      "poi_latitude": "36.1704936",
      "poi_longitude": "-86.66743679999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLYNj7XRpZIgRG-64HsiRZQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_82f994895bfef9e664bfc86f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Thorntons",
      "poi_type": "Shopping & Retail",
      "poi_address": "2815 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Convenience-store chain with grab-&-go food, packaged snacks & drinks, plus gasoline.",
      "poi_long_description": "Convenience-store chain with grab-&-go food, packaged snacks & drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c756-7683-a1da-93548882a34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c756-7683-a1da-93548882a34b",
        "storage_key": "property/6767906449167503/019f14e1-c756-7683-a1da-93548882a34b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thorntonsinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=617712386331278148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thorntons",
      "poi_latitude": "36.166824",
      "poi_longitude": "-86.66244499999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-886-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-be89-738e-8054-4696b971595e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb778-be89-738e-8054-4696b971595e",
        "storage_key": "property/6767906449167503/019eb778-be89-738e-8054-4696b971595e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJE_9YwH1pZIgRRHuigCSOkgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_5d8859b808ae77b068bb9bc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Shell",
      "poi_type": "Shopping & Retail",
      "poi_address": "2417 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Local petrol station providing fuel, oil changes, vehicle repairs and tire services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-d6aa-7773-9175-9ee920dd60cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-d6aa-7773-9175-9ee920dd60cd",
        "storage_key": "property/6767906449167503/019f14e1-d6aa-7773-9175-9ee920dd60cd.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/12405756-2417-lebanon-pike/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=16085677497313296116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "36.169013",
      "poi_longitude": "-86.68110569999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-883-0606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-be97-76b5-896c-9e3eb369f679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb778-be97-76b5-896c-9e3eb369f679",
        "storage_key": "property/6767906449167503/019eb778-be97-76b5-896c-9e3eb369f679.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1kKrXRpZIgR9H7aTnXOO98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_4a914dedd0d6b9e8943437b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Stanford Montessori Elementary School",
      "poi_type": "Education",
      "poi_address": "2417 Maplecrest Dr, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-9b5f-77eb-986e-ddbca773e896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-9b5f-77eb-986e-ddbca773e896",
        "storage_key": "property/6767906449167503/019eb778-9b5f-77eb-986e-ddbca773e896.webp",
        "width": 1280,
        "height": 827
      },
      "poi_business_url": "http://schools.mnps.org/stanford-montessori-elementary-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12756066766807605736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanford-montessori-elementary-school",
      "poi_latitude": "36.1758342",
      "poi_longitude": "-86.6818538",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-885-8822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmbUbrKFpZIgR6KG7ziOnBrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a3191ed89542ba9d9fb6f510",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "McGavock Elementary School",
      "poi_type": "Education",
      "poi_address": "275 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mcgavockelementary.mnps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722423275003008939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgavock-elementary-school",
      "poi_latitude": "36.160123",
      "poi_longitude": "-86.68034039999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-885-8912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRaUv4GxpZIgRq1fPaov9xyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0a417aae06184d9bf5f3d149",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson Middle School",
      "poi_type": "Education",
      "poi_address": "110 Stewarts Ferry Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-fdd5-72a5-bbc9-8c280fe1cf44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-fdd5-72a5-bbc9-8c280fe1cf44",
        "storage_key": "property/6767906449167503/019e3bd2-fdd5-72a5-bbc9-8c280fe1cf44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://donelson.mnps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5077645582714480479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-middle-school",
      "poi_latitude": "36.1666392",
      "poi_longitude": "-86.65630929999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-884-4080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ_3j29ZrZIgRXycHRcFrd0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_7ae64947f78fdeb8ec970f0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "McGavock High School",
      "poi_type": "Education",
      "poi_address": "3150 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-fcc1-76e1-9de2-9b6aaaf6a509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-fcc1-76e1-9de2-9b6aaaf6a509",
        "storage_key": "property/6767906449167503/019e3bd2-fcc1-76e1-9de2-9b6aaaf6a509.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://schools.mnps.org/mcgavock-high-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16608299479161621195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgavock-high-school",
      "poi_latitude": "36.1857207",
      "poi_longitude": "-86.67806499999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-885-8850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv2SydpdpZIgRy8q7umGIfOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5b447f8e6a50a11531dc2ebe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Tennessee School for the Blind",
      "poi_type": "Education",
      "poi_address": "115 Stewarts Ferry Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-01bf-73f6-9cfc-dba3dd51c726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-01bf-73f6-9cfc-dba3dd51c726",
        "storage_key": "property/6767906449167503/019e3bd3-01bf-73f6-9cfc-dba3dd51c726.webp",
        "width": 1280,
        "height": 641
      },
      "poi_business_url": "http://www.tsbtigers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9641013206492051950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tennessee-school-for-the-blind",
      "poi_latitude": "36.168219",
      "poi_longitude": "-86.6539025",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-231-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5b_QR0BmZIgR7vnOV27Cy4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6df5bd1dc74844fa6beb3b9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Rhythm & Rhymes Childcare LLC",
      "poi_type": "Education",
      "poi_address": "114 Cottage Ln, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0921-76ca-b120-93731bf415c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0921-76ca-b120-93731bf415c5",
        "storage_key": "property/6767906449167503/019e3bd3-0921-76ca-b120-93731bf415c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.r-n-rchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2243927839507630284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rhythm--rhymes-childcare-llc",
      "poi_latitude": "36.1682622",
      "poi_longitude": "-86.6929167",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-883-6436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ2BA4AVpZIgRzEh2L3sIJB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7c98e1c5d860183dcaac3181",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "The Montessori School of Donelson",
      "poi_type": "Education",
      "poi_address": "2525 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-e6a4-7778-bdc6-23389b98a5e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-e6a4-7778-bdc6-23389b98a5e0",
        "storage_key": "property/6767906449167503/019f14e1-e6a4-7778-bdc6-23389b98a5e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2228917160754045068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-montessori-school-of-donelson",
      "poi_latitude": "36.1691343",
      "poi_longitude": "-86.67733729999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-316-5667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2OqFHRpZIgRjGCEMFm07h4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ff7ce60ec32656a1563ac560",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson Christian Academy",
      "poi_type": "Education",
      "poi_address": "300 Danyacrest Dr, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-011e-769b-9dd1-1a0cf64a62b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-011e-769b-9dd1-1a0cf64a62b6",
        "storage_key": "property/6767906449167503/019e3bd3-011e-769b-9dd1-1a0cf64a62b6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.dcawildcats.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5386882334626009400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-christian-academy",
      "poi_latitude": "36.1824409",
      "poi_longitude": "-86.650559",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-883-2926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Z5nBzBqZIgRONE1QvEMwko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_33950635cc69efe4d5cf3704",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Holy Rosary Academy",
      "poi_type": "Education",
      "poi_address": "190 Graylynn Dr, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-9da5-72ec-9e40-01bdb03ce8c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-9da5-72ec-9e40-01bdb03ce8c9",
        "storage_key": "property/6767906449167503/019eb778-9da5-72ec-9e40-01bdb03ce8c9.webp",
        "width": 636,
        "height": 350
      },
      "poi_business_url": "https://www.holyrosary.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15031122141439806210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-rosary-academy",
      "poi_latitude": "36.1684356",
      "poi_longitude": "-86.6754406",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-883-1108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1WWPrXZpZIgRAksHCPNFmdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_9b5ec63473f59ae1588af8e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "NSCC East Davidson Campus",
      "poi_type": "Education",
      "poi_address": "2845 Elm Hill Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nscc.edu/campuses/east-davidson-campus.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282942932699594392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nscc-east-davidson-campus",
      "poi_latitude": "36.1471045",
      "poi_longitude": "-86.6632441",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-986-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaxpKJF9pZIgRmD44aJvIUEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_90b1687b60ab0617a1f419bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Grand Ole Opry",
      "poi_type": "Entertainment",
      "poi_address": "600 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Visitors come for daily tours & weekly live radio shows featuring classic & new country acts.",
      "poi_long_description": "Visitors come for daily tours & weekly live radio shows featuring classic & new country acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0474-731d-940b-b49e0843a197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0474-731d-940b-b49e0843a197",
        "storage_key": "property/6767906449167503/019e3bd3-0474-731d-940b-b49e0843a197.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.opry.com/?utm_campaign=opry&utm_medium=organicsearch&utm_source=googlemybusiness&utm_audience=tofu_googlemybusiness&utm_content=brandstory_google_my_business_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2845966795787791477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-ole-opry",
      "poi_latitude": "36.2068571",
      "poi_longitude": "-86.69210849999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSpg989pZIgRdex84bjnfic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_661ab4b32323861db968be5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Opry Mills",
      "poi_type": "Entertainment",
      "poi_address": "433 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_long_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c17e-759c-9865-04cc14e19eea",
        "storage_key": "property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.simon.com/mall/opry-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=13159961003414719041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "opry-mills",
      "poi_latitude": "36.2048497",
      "poi_longitude": "-86.6930726",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-514-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgz_abddpZIgRQQqH4s6SobY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_74e0dbffea41e2e645597955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Gaylord Opryland Resort & Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "2800 Opryland Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Upscale resort featuring a glass atrium, indoor gardens & pools, plus a spa & dining.",
      "poi_long_description": "Upscale resort featuring a glass atrium, indoor gardens & pools, plus a spa & dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-f001-776c-a28d-8e34bd773501.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f001-776c-a28d-8e34bd773501",
        "storage_key": "property/6767906449167503/019f14e1-f001-776c-a28d-8e34bd773501.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/bnago-gaylord-opryland-resort-and-convention-center/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=4236005428940527547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gaylord-opryland-resort--convention-center",
      "poi_latitude": "36.2122412",
      "poi_longitude": "-86.6946459",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 615-889-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3608-755e-aea8-bf6f62a09ee6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3608-755e-aea8-bf6f62a09ee6",
        "storage_key": "property/6767906449167503/019e3bd3-3608-755e-aea8-bf6f62a09ee6.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ_5bAt9BpZIgRu1egin5QyTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "ec_d524e184e268a9fdb1c6ae56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Madame Tussauds Nashville",
      "poi_type": "Entertainment",
      "poi_address": "Opry Mills, 515 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Wax replicas of past & present music stars such as Taylor Swift, Johnny Cash & Elvis Presley.",
      "poi_long_description": "Wax replicas of past & present music stars such as Taylor Swift, Johnny Cash & Elvis Presley.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-11ba-711d-87c5-7ed3f457c60d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-11ba-711d-87c5-7ed3f457c60d",
        "storage_key": "property/6767906449167503/019e3bd3-11ba-711d-87c5-7ed3f457c60d.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.madametussauds.com/nashville/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=1620238348461011238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madame-tussauds-nashville",
      "poi_latitude": "36.2048399",
      "poi_longitude": "-86.69404709999999",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-485-4867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feba-772a-bf4f-4139c8b82eb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feba-772a-bf4f-4139c8b82eb9",
        "storage_key": "property/6767906449167503/019e3bc7-feba-772a-bf4f-4139c8b82eb9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQ0Qdc9pZIgRJvF7izE-fBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_f90a8b71c0383f2d6eac7f8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "General Jackson Showboat",
      "poi_type": "Entertainment",
      "poi_address": "2812 Opryland Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Paddleboat cruising the Cumberland River, with a dining room & theater for musical performances.",
      "poi_long_description": "Paddleboat cruising the Cumberland River, with a dining room & theater for musical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0922-77bf-94ce-214e78b8f6c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0922-77bf-94ce-214e78b8f6c6",
        "storage_key": "property/6767906449167503/019e3bd3-0922-77bf-94ce-214e78b8f6c6.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "http://www.generaljackson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6043919699323735081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "general-jackson-showboat",
      "poi_latitude": "36.2037358",
      "poi_longitude": "-86.69516639999999",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-458-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6fb7M5pZIgRKUwtyfFQ4FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tour_agency"
    },
    {
      "id": "ec_6226c6e9cd3d13f2720a45a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Dave & Buster's Nashville",
      "poi_type": "Entertainment",
      "poi_address": "540 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0851-77f5-859d-b4ebcf2440ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0851-77f5-859d-b4ebcf2440ae",
        "storage_key": "property/6767906449167503/019e3bd3-0851-77f5-859d-b4ebcf2440ae.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/nashville",
      "poi_directions_map_url": "https://maps.google.com/?cid=11096768336280591231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-nashville",
      "poi_latitude": "36.2059495",
      "poi_longitude": "-86.69428549999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 615-970-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0kSAc9pZIgRf5vONgKk_5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_151adcdf81c2e72160bc775a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "The Nashville Palace",
      "poi_type": "Entertainment",
      "poi_address": "2611 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "Classic country music acts perform at this famed, rustic honkey-tonk with dancing & pub grub.",
      "poi_long_description": "Classic country music acts perform at this famed, rustic honkey-tonk with dancing & pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-a500-71f8-b3f9-29baa9ea3366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-a500-71f8-b3f9-29baa9ea3366",
        "storage_key": "property/6767906449167503/019eb778-a500-71f8-b3f9-29baa9ea3366.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.thefamousnashvillepalace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12779111596173292392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nashville-palace",
      "poi_latitude": "36.217732",
      "poi_longitude": "-86.698216",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-889-1541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-362b-779f-9246-f4a33713326c",
        "storage_key": "property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoT1BhtVpZIgRaPP7QkqGWLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_76c9a25d902cd3c7d14af6f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "McNamara's Irish Pub & Restaurant",
      "poi_type": "Entertainment",
      "poi_address": "2740 Old Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Classic Gaelic tavern food with a variety of whiskeys & beers, plus live music in a large playroom.",
      "poi_long_description": "Classic Gaelic tavern food with a variety of whiskeys & beers, plus live music in a large playroom.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd2-f279-7657-acdc-e5bf999fadb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd2-f279-7657-acdc-e5bf999fadb4",
        "storage_key": "property/6767906449167503/019e3bd2-f279-7657-acdc-e5bf999fadb4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.mcnamarasirishpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14469438715982049021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcnamaras-irish-pub--restaurant",
      "poi_latitude": "36.1687953",
      "poi_longitude": "-86.66447529999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-885-7262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feed-7611-89d8-9cb23804de06",
        "storage_key": "property/6767906449167503/019e3bc7-feed-7611-89d8-9cb23804de06.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2X4ijn5pZIgR_e5kjdnFzcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_restaurant"
    },
    {
      "id": "ec_54c12967bd8d27f774142e98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "The Donelson Pub",
      "poi_type": "Entertainment",
      "poi_address": "945 Allen Rd, Nashville, TN 37214, USA",
      "poi_short_description": "Cash-only dive bar featuring karaoke and regular live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-a0e0-743f-b7d9-62c1c7ae853f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-a0e0-743f-b7d9-62c1c7ae853f",
        "storage_key": "property/6767906449167503/019eb778-a0e0-743f-b7d9-62c1c7ae853f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7276037304861554038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-donelson-pub",
      "poi_latitude": "36.1502408",
      "poi_longitude": "-86.665742",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-889-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-362b-779f-9246-f4a33713326c",
        "storage_key": "property/6767906449167503/019e3bd3-362b-779f-9246-f4a33713326c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VZHc15pZIgRdnXD8GCt-WQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_fd5b33fc74d8e09ce3554fc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Two Rivers Park",
      "poi_type": "Entertainment",
      "poi_address": "3150 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-1862-7418-8cca-657e71bba385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-1862-7418-8cca-657e71bba385",
        "storage_key": "property/6767906449167503/019e3bd3-1862-7418-8cca-657e71bba385.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nashville.gov/departments/parks/parks/two-rivers-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2871266824483306999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "36.1869369",
      "poi_longitude": "-86.68384650000002",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-862-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-abc11cda1dca",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Zs1ve5pZIgR9_2w2PbJ2Cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_11aba3dbbdad072e190b09a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "TriStar Summit Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5655 Frist Blvd, Hermitage, TN 37076, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-eef1-73b9-b595-398a2aec5ace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-eef1-73b9-b595-398a2aec5ace",
        "storage_key": "property/6767906449167503/019e3bc7-eef1-73b9-b595-398a2aec5ace.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tristarhealth.com/locations/tristar-summit-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2260574234215876175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tristar-summit-medical-center",
      "poi_latitude": "36.175882",
      "poi_longitude": "-86.60789419999999",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-316-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febc-742a-96e3-347f3e44d4c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febc-742a-96e3-347f3e44d4c3",
        "storage_key": "property/6767906449167503/019e3bc7-febc-742a-96e3-347f3e44d4c3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4cJduNqZIgRT4bW-kksXx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_6e742b2c38cc3a203c76a001",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Urgent Care - Nashville, Donelson",
      "poi_type": "Health and Wellness",
      "poi_address": "2412 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0eac-7171-8a50-7e9e99848a87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0eac-7171-8a50-7e9e99848a87",
        "storage_key": "property/6767906449167503/019e3bd3-0eac-7171-8a50-7e9e99848a87.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "https://www.urgentteam.com/locations/ascension-saint-thomas-donelson-nashville-tn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1425200389380713252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-urgent-care---nashville-donelson",
      "poi_latitude": "36.169471",
      "poi_longitude": "-86.6813907",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-647-3578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxqaOpZpZIgRJCvJ_jNUxxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e81ba4391d00a86da6becf65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2531 Elm Hill Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-a50c-72e2-93ee-64b460bf9c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-a50c-72e2-93ee-64b460bf9c23",
        "storage_key": "property/6767906449167503/019eb778-a50c-72e2-93ee-64b460bf9c23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=235810470157230248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "36.1513123",
      "poi_longitude": "-86.6773812",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-883-6995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0ckw0FpZIgRqCAKjF_ERQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_15fd1b9cc03067a91a328a1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "143 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-128d-7036-a12b-fbf6d0052c4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-128d-7036-a12b-fbf6d0052c4c",
        "storage_key": "property/6767906449167503/019e3bd3-128d-7036-a12b-fbf6d0052c4c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/026/00845?cid=loc_02600845P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1275725960584923818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "36.1709903",
      "poi_longitude": "-86.6787629",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-889-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3619-744f-8b66-218f872423be",
        "storage_key": "property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01nR5XRpZIgRqopohwBKtBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_896e553f84b4fdff7555c89a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "518 Donelson Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-1108-755b-aa9d-aef23c44fee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-1108-755b-aa9d-aef23c44fee1",
        "storage_key": "property/6767906449167503/019e3bd3-1108-755b-aa9d-aef23c44fee1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-518+donelson+pike-nashville-tn-37214/id=3401",
      "poi_directions_map_url": "https://maps.google.com/?cid=10246051044852097970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "36.1484459",
      "poi_longitude": "-86.6671313",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-883-5108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3619-744f-8b66-218f872423be",
        "storage_key": "property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcJDN1xpZIgRsuPtriNJMY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3bb57ebf120b3507c273a4e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c695-76b8-9a58-a613f141ce52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c695-76b8-9a58-a613f141ce52",
        "storage_key": "property/6767906449167503/019f14e1-c695-76b8-9a58-a613f141ce52.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.cvs.com/store-locator/nashville-tn-pharmacies/2500-lebanon-pike-nashville-tn-37214/storeid=6427?WT.mc_id=LS_GOOGLE_FS_6427",
      "poi_directions_map_url": "https://maps.google.com/?cid=17186356669125979677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.1699853",
      "poi_longitude": "-86.67927379999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-889-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYNj7XRpZIgRHW5rVlU0gu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_32641b9cc23b8d143e83b652",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Publix Pharmacy at The Crossings",
      "poi_type": "Health and Wellness",
      "poi_address": "2324 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-01f6-7368-812d-2b61852626d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-01f6-7368-812d-2b61852626d4",
        "storage_key": "property/6767906449167503/019f14e2-01f6-7368-812d-2b61852626d4.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=15140878848482855636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-the-crossings",
      "poi_latitude": "36.1708319",
      "poi_longitude": "-86.6840423",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-884-2771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3619-744f-8b66-218f872423be",
        "storage_key": "property/6767906449167503/019e3bd3-3619-744f-8b66-218f872423be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUKWeAtpZIgR1MoLxxc1H9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_bc3ff068592f9598c4f78075",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "TruFit Athletic Clubs - Donelson",
      "poi_type": "Health and Wellness",
      "poi_address": "3051 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Membership-only gym featuring basketball courts, massage chairs, and a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-ebfb-7666-b116-bcc2de5e8baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-ebfb-7666-b116-bcc2de5e8baf",
        "storage_key": "property/6767906449167503/019e3bc7-ebfb-7666-b116-bcc2de5e8baf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trufitathleticclubs.com/locations/tn/nashville-donelson/?utm_source=google&utm_medium=organic&utm_campaign=gmp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1207688980630219712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trufit-athletic-clubs---donelson",
      "poi_latitude": "36.1764081",
      "poi_longitude": "-86.6441354",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 629-895-3477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5pxk09rZIgRwCuesbqSwhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4c3896e8f3b15f85a956345a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson-Hermitage Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Family-friendly gym featuring fitness classes, pools and a sauna, plus a child care center.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-e6c2-724f-8a3d-0576979f6947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-e6c2-724f-8a3d-0576979f6947",
        "storage_key": "property/6767906449167503/019e3bc7-e6c2-724f-8a3d-0576979f6947.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcamidtn.org/locations/donelson?utm_source=googlemybusiness&utm_medium=organic&utm_campaign=Google-My-Business",
      "poi_directions_map_url": "https://maps.google.com/?cid=16922325566153362300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-hermitage-family-ymca",
      "poi_latitude": "36.1718493",
      "poi_longitude": "-86.6486501",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-889-2632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcYtPc1rZIgRfAsVsHEt2Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f47422f61667b0ab800212e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "2428 Lebanon Pike, Nashville, TN 37214, USA",
      "poi_short_description": "Local studio specializing in hot yoga classes, including sculpt and flow.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-14e3-747f-aa41-00b5f1604078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-14e3-747f-aa41-00b5f1604078",
        "storage_key": "property/6767906449167503/019e3bd3-14e3-747f-aa41-00b5f1604078.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.donelsonhotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2749932692830988109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-hot-yoga",
      "poi_latitude": "36.1696993",
      "poi_longitude": "-86.6802881",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-549-6745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6pOv3RpZIgRTads4Da5KSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b5734dcfc8edd22e12b7ee42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nashville Youth Soccer Association",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3135 Heartland Dr, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-377e-767f-b86b-1c826b985693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-377e-767f-b86b-1c826b985693",
        "storage_key": "property/6767906449167503/019f14e2-377e-767f-b86b-1c826b985693.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.nysa-soccer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13376660901143057100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-youth-soccer-association",
      "poi_latitude": "36.1869503",
      "poi_longitude": "-86.6681049",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-971-4149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnfdV745pZIgRzBJ9jTdyo7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "ec_fc231b1cc4309a5db053c1c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Stones River Greenway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3778 Bell Rd, Hermitage, TN 37076, USA",
      "poi_short_description": "Paved multi-use trail popular with walkers, runners, and cyclists, featuring bridges and scenic views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-1a07-705b-886f-a656c993328c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-1a07-705b-886f-a656c993328c",
        "storage_key": "property/6767906449167503/019e3bd3-1a07-705b-886f-a656c993328c.webp",
        "width": 707,
        "height": 533
      },
      "poi_business_url": "https://www.nashville.gov/departments/parks/greenways-and-open-space",
      "poi_directions_map_url": "https://maps.google.com/?cid=12871163308953045975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-greenway-trailhead",
      "poi_latitude": "36.15875279999999",
      "poi_longitude": "-86.6209088",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-862-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3FFWqdrZIgR1wswzNWOn7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_b752592d37d1364418561ebb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Two Rivers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3150 McGavock Pk, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-1862-7418-8cca-657e71bba385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-1862-7418-8cca-657e71bba385",
        "storage_key": "property/6767906449167503/019e3bd3-1862-7418-8cca-657e71bba385.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nashville.gov/departments/parks/parks/two-rivers-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2871266824483306999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "36.1869369",
      "poi_longitude": "-86.68384650000002",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-862-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-abc11cda1dca",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Zs1ve5pZIgR9_2w2PbJ2Cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_accbf5c726104e8d25b32432",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Wave Country",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2320 Two Rivers Pkwy, Nashville, TN 37214, USA",
      "poi_short_description": "Water flumes, speed slides & wave-action pools draw patrons to this attraction during the summer.",
      "poi_long_description": "Water flumes, speed slides & wave-action pools draw patrons to this attraction during the summer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-14b8-751c-951e-78932d2d5f71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-14b8-751c-951e-78932d2d5f71",
        "storage_key": "property/6767906449167503/019e3bd3-14b8-751c-951e-78932d2d5f71.webp",
        "width": 427,
        "height": 320
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7547677338655763657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wave-country",
      "poi_latitude": "36.1871422",
      "poi_longitude": "-86.6882138",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-885-1092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bSeabtpZIgRyazX2Yy8vmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "ec_fa009afc6230d2851728b2a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Cumberland Pedestrian Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-e65d-75dd-8e91-d40a74d72ce5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-e65d-75dd-8e91-d40a74d72ce5",
        "storage_key": "property/6767906449167503/019e3bc7-e65d-75dd-8e91-d40a74d72ce5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=984295971048205358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cumberland-pedestrian-bridge",
      "poi_latitude": "36.1901433",
      "poi_longitude": "-86.6904194",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9JiGbppZIgRLiwtfPjrqA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_3996886d27dd8461c9afe8d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Gaylord Springs Golf Links",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18 Springhouse Ln, Nashville, TN 37214, USA",
      "poi_short_description": "Scottish links-style par 72 golf course with a stylish clubhouse available to hire for events.",
      "poi_long_description": "Scottish links-style par 72 golf course with a stylish clubhouse available to hire for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-1b27-761f-9af3-94c3e1b6bec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-1b27-761f-9af3-94c3e1b6bec1",
        "storage_key": "property/6767906449167503/019e3bd3-1b27-761f-9af3-94c3e1b6bec1.webp",
        "width": 1280,
        "height": 723
      },
      "poi_business_url": "http://www.gaylordsprings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8477618207366799517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gaylord-springs-golf-links",
      "poi_latitude": "36.220416",
      "poi_longitude": "-86.6806469",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 615-458-1730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fec7-74cc-bcfb-2ae003a477e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fec7-74cc-bcfb-2ae003a477e5",
        "storage_key": "property/6767906449167503/019e3bc7-fec7-74cc-bcfb-2ae003a477e5.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUd5LwtCZIgRnWB739eMpnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_06f0ca1cb7eb00b1c7d92b34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Andrew Jackson’s Hermitage",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4580 Rachels Ln, Hermitage, TN 37076, USA",
      "poi_short_description": "Greek Revival mansion museum & historic site telling Jackson's life story through exhibits & tours.",
      "poi_long_description": "Greek Revival mansion museum & historic site telling Jackson's life story through exhibits & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-3453-70be-bc39-8a97893b7300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3453-70be-bc39-8a97893b7300",
        "storage_key": "property/6767906449167503/019f14e2-3453-70be-bc39-8a97893b7300.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thehermitage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7186269056876293187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andrew-jacksons-hermitage",
      "poi_latitude": "36.2138698",
      "poi_longitude": "-86.61620020000001",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-889-2941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feba-772a-bf4f-4139c8b82eb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feba-772a-bf4f-4139c8b82eb9",
        "storage_key": "property/6767906449167503/019e3bc7-feba-772a-bf4f-4139c8b82eb9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2rnpoJqZIgRQyx--6HBumM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_deeed1eb546ac0596d50fe7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Long Hunter State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2910 Hobson Pike, Hermitage, TN 37076, USA",
      "poi_short_description": "Park with hiking & biking trails, fishing plus Native-American archaeology site with mound.",
      "poi_long_description": "Park with hiking & biking trails, fishing plus Native-American archaeology site with mound.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-f274-71a3-a59e-eb6ec25b5ace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-f274-71a3-a59e-eb6ec25b5ace",
        "storage_key": "property/6767906449167503/019e3bc7-f274-71a3-a59e-eb6ec25b5ace.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tnstateparks.com/parks/long-hunter",
      "poi_directions_map_url": "https://maps.google.com/?cid=11374303720361865519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-hunter-state-park",
      "poi_latitude": "36.09251440000001",
      "poi_longitude": "-86.5555265",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-885-2422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-abc11cda1dca",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-abc11cda1dca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2yy5KUTZIgRL7GSU_ik2Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_97ef25a921aa0471af3f37f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nashville Shores Lakeside Resort",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 Bell Rd, Hermitage, TN 37076, USA",
      "poi_short_description": "Visitors play in the lagoon, slide down water flumes, ride on zip lines or rent boats on the lake.",
      "poi_long_description": "Visitors play in the lagoon, slide down water flumes, ride on zip lines or rent boats on the lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-a1e5-7110-98ae-9c09ef6dc36e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-a1e5-7110-98ae-9c09ef6dc36e",
        "storage_key": "property/6767906449167503/019eb778-a1e5-7110-98ae-9c09ef6dc36e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nashvilleshores.com/lodging/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674821185632899988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-shores-lakeside-resort",
      "poi_latitude": "36.1584115",
      "poi_longitude": "-86.6030188",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-889-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-be96-72e1-8504-2f977765edaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb778-be96-72e1-8504-2f977765edaa",
        "storage_key": "property/6767906449167503/019eb778-be96-72e1-8504-2f977765edaa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL1neLxdrZIgRlJPyp_4oPhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "ec_dfee29df21d4fe06abefa16d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Hermitage Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3939 Old Hickory Blvd, Old Hickory, TN 37138, USA",
      "poi_short_description": "Membership or day-rate golf club offering a bar & grill, 2 scenic courses & onsite lodging.",
      "poi_long_description": "Membership or day-rate golf club offering a bar & grill, 2 scenic courses & onsite lodging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-18f3-76dd-917a-c3b7054fadc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-18f3-76dd-917a-c3b7054fadc1",
        "storage_key": "property/6767906449167503/019f14e2-18f3-76dd-917a-c3b7054fadc1.webp",
        "width": 1280,
        "height": 821
      },
      "poi_business_url": "https://www.hermitagegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5712226832783626787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hermitage-golf-course",
      "poi_latitude": "36.2347717",
      "poi_longitude": "-86.6381772",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 615-847-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fec7-74cc-bcfb-2ae003a477e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fec7-74cc-bcfb-2ae003a477e5",
        "storage_key": "property/6767906449167503/019e3bc7-fec7-74cc-bcfb-2ae003a477e5.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJySHJlslBZIgRI9KFLAroRU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_1525b6d81d29d2a4f6d56fa0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Donelson Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-22a2-705a-8061-776917973f58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-22a2-705a-8061-776917973f58",
        "storage_key": "property/6767906449167503/019e3bd3-22a2-705a-8061-776917973f58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wegotransit.com/ride/transit-services/train/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14208230993785705285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donelson-station",
      "poi_latitude": "36.166995",
      "poi_longitude": "-86.6665179",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-862-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMw8PCnxpZIgRRdNKd8_GLcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "ec_04ce7ed269478d9465e18710",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Hermitage Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Nashville, TN 37076, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-ac81-70fb-998f-ee19036a6363.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-ac81-70fb-998f-ee19036a6363",
        "storage_key": "property/6767906449167503/019eb778-ac81-70fb-998f-ee19036a6363.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wegotransit.com/ride/transit-services/train/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10832154259049174855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hermitage-station",
      "poi_latitude": "36.190235",
      "poi_longitude": "-86.60561",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81lxh-tqZIgRR1fcSuiKU5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_a1423d9c3d9159e833433c44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Riverfront",
      "poi_type": "Transportation & Transit",
      "poi_address": "Nashville, TN 37201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-2612-7598-b81e-0fe1ab1eeba3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-2612-7598-b81e-0fe1ab1eeba3",
        "storage_key": "property/6767906449167503/019e3bd3-2612-7598-b81e-0fe1ab1eeba3.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "https://www.wegotransit.com/ride/transit-services/train/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8803360910794582622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront",
      "poi_latitude": "36.1620139",
      "poi_longitude": "-86.77375959999999",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ088KDltmZIgRXmp4LRvSK3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "ec_5a5e8a6593c69dc4fb6713fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nashville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b",
        "storage_key": "property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc8-011c-726b-b887-4f4d09c3c2cc",
        "storage_key": "property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b231c8f65e7ead7152ca24d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "BNA Cell Waiting Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "1415 Murfreesboro Pike, Nashville, TN 37217, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-2b4d-77ff-94bf-20ed4842cf57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-2b4d-77ff-94bf-20ed4842cf57",
        "storage_key": "property/6767906449167503/019f14e2-2b4d-77ff-94bf-20ed4842cf57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flynashville.com/park-at-bna#CellPhoneWaitingLotAreas",
      "poi_directions_map_url": "https://maps.google.com/?cid=7277866916214471140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bna-cell-waiting-lot",
      "poi_latitude": "36.1123967",
      "poi_longitude": "-86.6898059",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3628-71f7-938a-caa899855412.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3628-71f7-938a-caa899855412",
        "storage_key": "property/6767906449167503/019e3bd3-3628-71f7-938a-caa899855412.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdzvppVvZIgR5PmHh2YtAGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_8c51497efdf8a6fd586d9681",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "256 Stewarts Ferry Pike #40",
      "poi_type": "Transportation & Transit",
      "poi_address": "256 Stewarts Ferry Pike #40, Nashville, TN 37214, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9649971897230396473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "256-stewarts-ferry-pike-40",
      "poi_latitude": "36.1614733",
      "poi_longitude": "-86.6472287",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7zJ8sVrZIgROYzrElCW64U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_56fc1f6baaa34b3bef065469",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nashville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b",
        "storage_key": "property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc8-011c-726b-b887-4f4d09c3c2cc",
        "storage_key": "property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_96500e1d31ca4d674d09389a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Wego Public Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "130 Nestor St, Nashville, TN 37210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-b071-73f9-81a6-c849867c1891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-b071-73f9-81a6-c849867c1891",
        "storage_key": "property/6767906449167503/019eb778-b071-73f9-81a6-c849867c1891.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://wegotransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11078024265502457516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wego-public-transit",
      "poi_latitude": "36.1577465",
      "poi_longitude": "-86.7556221",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-862-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe7q-z6RDZIgRrH5uJmAMvZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_b1b50b4b13e78584adb7eeb1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Nashville International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b",
        "storage_key": "property/6767906449167503/019e3bc7-f5f7-74bd-8e73-159fcdbf3d7b.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc8-011c-726b-b887-4f4d09c3c2cc",
        "storage_key": "property/6767906449167503/019e3bc8-011c-726b-b887-4f4d09c3c2cc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_9148368d0ab5c0a4c3926a55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Gaylord Opryland Resort & Convention Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Opryland Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Upscale resort featuring a glass atrium, indoor gardens & pools, plus a spa & dining.",
      "poi_long_description": "Upscale resort featuring a glass atrium, indoor gardens & pools, plus a spa & dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-f001-776c-a28d-8e34bd773501.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f001-776c-a28d-8e34bd773501",
        "storage_key": "property/6767906449167503/019f14e1-f001-776c-a28d-8e34bd773501.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/bnago-gaylord-opryland-resort-and-convention-center/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=4236005428940527547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gaylord-opryland-resort--convention-center",
      "poi_latitude": "36.2122412",
      "poi_longitude": "-86.6946459",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 615-889-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-3608-755e-aea8-bf6f62a09ee6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bd3-3608-755e-aea8-bf6f62a09ee6",
        "storage_key": "property/6767906449167503/019e3bd3-3608-755e-aea8-bf6f62a09ee6.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ_5bAt9BpZIgRu1egin5QyTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "ec_dcd74302f9c8b7efe2c9f224",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Grand Ole Opry",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Visitors come for daily tours & weekly live radio shows featuring classic & new country acts.",
      "poi_long_description": "Visitors come for daily tours & weekly live radio shows featuring classic & new country acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-0474-731d-940b-b49e0843a197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-0474-731d-940b-b49e0843a197",
        "storage_key": "property/6767906449167503/019e3bd3-0474-731d-940b-b49e0843a197.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.opry.com/?utm_campaign=opry&utm_medium=organicsearch&utm_source=googlemybusiness&utm_audience=tofu_googlemybusiness&utm_content=brandstory_google_my_business_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2845966795787791477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-ole-opry",
      "poi_latitude": "36.2068571",
      "poi_longitude": "-86.69210849999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSpg989pZIgRdex84bjnfic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_95ab1ec59e1bdfb6e9568eac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Opry Mills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "433 Opry Mills Dr, Nashville, TN 37214, USA",
      "poi_short_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_long_description": "Vast shopping mall featuring upscale retailers, a large food court, diverse restaurants & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-c17e-759c-9865-04cc14e19eea",
        "storage_key": "property/6767906449167503/019f14e1-c17e-759c-9865-04cc14e19eea.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.simon.com/mall/opry-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=13159961003414719041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "opry-mills",
      "poi_latitude": "36.2048497",
      "poi_longitude": "-86.6930726",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-514-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febb-7488-acc6-af079335c017",
        "storage_key": "property/6767906449167503/019e3bc7-febb-7488-acc6-af079335c017.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgz_abddpZIgRQQqH4s6SobY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_cc745010b6af7659bf702e03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Vanderbilt University Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1211 Medical Center Dr, Nashville, TN 37232, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-2b37-7001-8247-aa9be28fcd9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-2b37-7001-8247-aa9be28fcd9f",
        "storage_key": "property/6767906449167503/019e3bd3-2b37-7001-8247-aa9be28fcd9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vanderbilthealth.com/locations/vanderbilt-university-medical-center?utm_source=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=18045894809591446874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vanderbilt-university-medical-center",
      "poi_latitude": "36.1417928",
      "poi_longitude": "-86.8009699",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 615-322-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1GqhZhmZIgRWn3D07flb_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_0a09fcd72a2d78a11ac70bb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Vanderbilt University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2301 Vanderbilt Pl, Nashville, TN 37235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-2dee-76d6-93cb-618598585725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-2dee-76d6-93cb-618598585725",
        "storage_key": "property/6767906449167503/019e3bd3-2dee-76d6-93cb-618598585725.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.vanderbilt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10855076250909852324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vanderbilt-university",
      "poi_latitude": "36.1460568",
      "poi_longitude": "-86.8030167",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 615-322-2934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-fefa-7028-a477-a457223d357c",
        "storage_key": "property/6767906449167503/019e3bc7-fefa-7028-a477-a457223d357c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoX0Ta71mZIgRpMJCaVb6pJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_280310ff604fd775e8541a3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Hospital Midtown",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Church St, Nashville, TN 37203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f14e2-3d0c-75e9-9c7d-dbaa2c972c94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3d0c-75e9-9c7d-dbaa2c972c94",
        "storage_key": "property/6767906449167503/019f14e2-3d0c-75e9-9c7d-dbaa2c972c94.webp",
        "width": 512,
        "height": 341
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/tennessee/tnnas/nashville-ascension-saint-thomas-hospital-midtown?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10602886913665196218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-hospital-midtown",
      "poi_latitude": "36.1542392",
      "poi_longitude": "-86.80199929999999",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 615-284-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-febc-742a-96e3-347f3e44d4c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-febc-742a-96e3-347f3e44d4c3",
        "storage_key": "property/6767906449167503/019e3bc7-febc-742a-96e3-347f3e44d4c3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93yy179mZIgRuuCmsngFJZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_d02a054c2410d1d73d5d59a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "HCA Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Park Plaza, Nashville, TN 37203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-2b35-729a-9bac-c917280ddc53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-2b35-729a-9bac-c917280ddc53",
        "storage_key": "property/6767906449167503/019e3bd3-2b35-729a-9bac-c917280ddc53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hcahealthcare.com/locations/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10284113910149410517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare",
      "poi_latitude": "36.1532079",
      "poi_longitude": "-86.81443759999999",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 615-344-9551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9RtvLdmZIgR1e4bHB2DuI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_4970d1a0b140489644515051",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Bridgestone Tower - Bridgestone Americas Corporate HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 4th Ave S, Nashville, TN 37201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bd3-2ad8-70fd-a0a5-ff74ae04c3d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e3bd3-2ad8-70fd-a0a5-ff74ae04c3d2",
        "storage_key": "property/6767906449167503/019e3bd3-2ad8-70fd-a0a5-ff74ae04c3d2.webp",
        "width": 917,
        "height": 1280
      },
      "poi_business_url": "http://www.bridgestoneamericas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242678297426998761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgestone-tower---bridgestone-americas-corporate-hq",
      "poi_latitude": "36.1589368",
      "poi_longitude": "-86.77543349999999",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 615-937-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e3bc7-feef-7584-8f5a-c6572ed834b1",
        "storage_key": "property/6767906449167503/019e3bc7-feef-7584-8f5a-c6572ed834b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-j8QVxmZIgR6TU52FPhPhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_b3784ccc5a2e27801ab27820",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "poi_name": "Tennessee State Capitol",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Dr. M.L.K. Jr Blvd, Nashville, TN 37243, USA",
      "poi_short_description": "Greek Revival 1845-1859 legislative building & grounds housing the tomb of President James K. Polk.",
      "poi_long_description": "Greek Revival 1845-1859 legislative building & grounds housing the tomb of President James K. Polk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-b270-7344-b4ec-5e3b64a514b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb778-b270-7344-b4ec-5e3b64a514b4",
        "storage_key": "property/6767906449167503/019eb778-b270-7344-b4ec-5e3b64a514b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.capitol.tn.gov/about/capitolvisit.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1255106270164848382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tennessee-state-capitol",
      "poi_latitude": "36.1657985",
      "poi_longitude": "-86.78422750000001",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 615-741-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019eb778-bea4-706c-8e33-747bae036566.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb778-bea4-706c-8e33-747bae036566",
        "storage_key": "property/6767906449167503/019eb778-bea4-706c-8e33-747bae036566.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs8eMBlhmZIgR_o6KvIAIaxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5f86672d-68a9-4588-851e-e36123da2414",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aab35d02-8c68-41aa-81c6-c9972c72b3c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_93e252c6-204d-4e87-a67e-0a023e87ecf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5abce93d-89c7-42df-8d44-6c648a87ad42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_08799bd7-20b7-429d-b555-f35a39ad4fdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_62669f71-915c-4649-a646-3861c2dd89e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f3c52c08-9469-40a3-aa8e-84d9b8e52a4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_97410fc222177a6bfe1e6ff0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "rating": "5",
      "name": "Laurie Shannon",
      "text": "I have lived at The Hamptons at Woodland Pointe for over 8 years. I love that the community is quiet, safe and clean and has great amenities. The office staff and maintenance team are always friendly.",
      "date": "2025-10-24",
      "title": "false"
    },
    {
      "id": "ec_b28f2a0672b3eaf6da7d6664",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "rating": "5",
      "name": "Jessica Sayeg",
      "text": "I’ve lived here for about 4 years now and I absolutely love it. It’s the closest I’ve felt to living in a home while still being in an apartment. The staff, community, and its amenities are lovely. Maintenance requests are always handled timely. All entrances are on the ground level, even if you’re on the second floor. There’s no need to scan into an elevator and walk down long hallways to find your door. Park, unlock your door, and go inside. 10/10 would recommend living here.",
      "date": "2024-08-27",
      "title": "false"
    },
    {
      "id": "ec_039339370a43496b99a60335",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "rating": "5",
      "name": "Kaitlin Schifano",
      "text": "My husband and I lived at the Hamptons for two years and loved it. The community is very quiet and safe. The whole staff is great, and Diane always goes above and beyond. Any issues that popped up during our time were addressed quickly and effectively. I’d happily recommend the Hamptons to any of my friends/ family in the nashville area.",
      "date": "2024-04-11",
      "title": "false"
    },
    {
      "id": "ec_38e8d694edb140f90c6c87c0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "rating": "5",
      "name": "Sierra Schneider",
      "text": "Had a few small issues upon move in, but the office and maintenance have been amazing at communication and correcting any problems. So happy with my choice to call this place my new home. Diane, Erika , and Sara have all been great from start to finish. Will happily recommend this place to anyone!",
      "date": "2024-03-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c0fc0a371a1138b99815f93d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bca-dbd8-718c-9dd8-3183114ebe41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bca-dbd8-718c-9dd8-3183114ebe41",
        "storage_key": "property/6767906449167503/019e3bca-dbd8-718c-9dd8-3183114ebe41.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,393 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KuetEripofb"
    },
    {
      "id": "ec_b04ffee2201f47a6de4235a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bca-daf3-77cb-9910-47b66ce018e8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bca-daf3-77cb-9910-47b66ce018e8",
        "storage_key": "property/6767906449167503/019e3bca-daf3-77cb-9910-47b66ce018e8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MrYk73Pbk3x"
    },
    {
      "id": "ec_0e7f174a7cafcc45ce7cf96d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e3bca-da5b-72ee-b12b-a28ec7eb6a78.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e3bca-da5b-72ee-b12b-a28ec7eb6a78",
        "storage_key": "property/6767906449167503/019e3bca-da5b-72ee-b12b-a28ec7eb6a78.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Internet Cafe",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NqJR9CrzAjh"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019eb778-0df3-765a-b659-fd3460802109",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "american-landmark-woodland-pointe-residences",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503"
    },
    {
      "lead_collector_id": "019f8fa0-5a2a-7269-8f0a-a67c3a985244",
      "lead_source": "LANDING_PAGE",
      "name": "Woodland Pointe  Residences Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-hermitage-tn-286",
      "search_query": "luxury apartments with pool hermitage tn",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Hermitage, TN",
      "h2_subtitle": "Discover your dream luxury apartment with a pool in Hermitage, TN. Woodland Pointe Residences offers modern amenities and scenic surroundings.",
      "page_copy": "Welcome to Woodland Pointe Residences, where luxury meets convenience in Hermitage, TN. Our stunning luxury apartments with pool provide an oasis of relaxation and comfort. With customized floor plans offering one to three bedrooms, each unit features gourmet kitchens and vaulted ceilings. The community boasts a sparkling pool perfect for unwinding after a busy day. \n\nNestled in Nashville, our residences are more than just a place to live—they're a lifestyle. Whether you're enjoying the picnic and BBQ areas or spending time in our stylish clubhouse, you'll find abundant opportunities for leisure. Experience the best in apartment living with our top-notch amenities and on-site property management, all designed to cater to your every need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Hermitage, TN",
      "seo_description": "Discover luxury living with a pool in Hermitage, TN at Woodland Pointe Residences. Enjoy spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "nashville-apartments-with-dedicated-parking-849",
      "search_query": "nashville apartments with dedicated parking",
      "category": "Amenity",
      "h1_title": "Nashville Apartments with Dedicated Parking",
      "h2_subtitle": "Experience convenience with Nashville apartments featuring dedicated parking. Woodland Pointe Residences meets all your living needs.",
      "page_copy": "Situated in the vibrant city of Nashville, TN, Woodland Pointe Residences offers apartments with dedicated parking, ensuring hassle-free living every day. Our community features thoughtfully designed one, two, and three-bedroom floor plans, equipped with modern amenities like gourmet kitchens and vaulted ceilings. \n\nLiving here means enjoying access to luxurious amenities, including a swimming pool, clubhouse, and picnic areas. Our dedicated parking ensures that you always have a convenient spot waiting for you. With a secured environment and a property manager on-site, Woodland Pointe ensures a perfect blend of comfort and convenience in the heart of Nashville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nashville Apartments with Dedicated Parking",
      "seo_description": "Find convenience with dedicated parking at Woodland Pointe Residences. Enjoy modern living in Nashville's best apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-with-bark-park-nashville-tn-51",
      "search_query": "pet-friendly apartments with bark park nashville tn",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Bark Park in Nashville",
      "h2_subtitle": "Explore pet-friendly apartments featuring a bark park in Nashville, TN. Woodland Pointe Residences offers amenities for both you and your furry friends.",
      "page_copy": "At Woodland Pointe Residences, we understand that pets are family. That's why our pet-friendly apartments include a bark park, providing a perfect spot for your dog to play and socialize. Enjoy spacious living with one, two, and three-bedroom layouts, and indulge in features like gourmet kitchens and vaulted ceilings.\n\nLocated in the vibrant city of Nashville, TN, our community goes beyond just pet accommodation. Relax by our pool or explore the scenic BBQ and picnic areas. We ensure a vibrant community lifestyle, with amenities like a modern clubhouse and on-site property manager, making sure all your needs are met in a pet-friendly environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Bark Park in Nashville",
      "seo_description": "Woodland Pointe offers pet-friendly living with a bark park in Nashville. Enjoy spacious apartments and amenities catering to you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-davidson-county-91",
      "search_query": "apartments with air conditioning davidson county",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Davidson County",
      "h2_subtitle": "Stay comfortable in Davidson County with apartments featuring air conditioning. Woodland Pointe Residences offers modern and cozy living spaces.",
      "page_copy": "Woodland Pointe Residences in Davidson County provides the perfect blend of comfort and style with apartments featuring efficient air conditioning. Our spacious one, two, and three-bedroom floor plans are designed to keep you comfortable throughout the seasons. Enjoy beautiful interiors with features like gourmet kitchens and elegant vaulted ceilings.\n\nBeyond the comfort of your apartment, the community offers a range of amenities including a refreshing swimming pool, picnic areas, and a well-equipped clubhouse. Our dedicated on-site management ensures a seamless living experience. Located in Nashville, TN, Woodland Pointe is the ideal choice for those seeking air-conditioned living in a vibrant community setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Davidson County",
      "seo_description": "Discover comfortable living with air-conditioned apartments in Davidson County at Woodland Pointe Residences. Enjoy modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "hermitage-apartments-with-in-unit-laundry-186",
      "search_query": "hermitage apartments with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Hermitage Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience the convenience of Hermitage apartments featuring in-unit laundry at Woodland Pointe Residences. Enjoy modern living tailored to you.",
      "page_copy": "Nestled in the scenic Hermitage area of Nashville, TN, Woodland Pointe Residences offers apartments equipped with the convenience of in-unit laundry. Our spacious one, two, and three-bedroom floor plans cater to modern lifestyles, featuring gourmet kitchens and vaulted ceilings.\n\nThis pet-friendly community provides a range of amenities including a sparkling swimming pool, picnic areas, and a welcoming clubhouse. With a property manager on-site and a security system in place, residents enjoy a comfortable and secure living environment. Choose Woodland Pointe for the perfect mix of convenience and contemporary living in Hermitage.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hermitage Apartments with In-Unit Laundry",
      "seo_description": "Find convenience in Hermitage with in-unit laundry at Woodland Pointe Residences. Enjoy modern amenities and spacious layouts in Nashville, TN.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-in-hermitage-tn-16",
      "search_query": "one bedroom apartments in Hermitage TN",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hermitage, TN",
      "h2_subtitle": "Discover spacious one-bedroom apartments in Hermitage, TN at Woodland Pointe Residences. Experience comfort and style in a vibrant community.",
      "page_copy": "At Woodland Pointe Residences, our one-bedroom apartments in Hermitage, TN offer ideal spaces for those seeking a cozy yet stylish living environment. Each apartment features modern amenities including vaulted ceilings and gourmet kitchens that ensure a comfortable lifestyle.\n\nEnjoy the community’s serene picnic areas, a refreshing pool, and a welcoming clubhouse perfect for socializing with neighbors. With on-site management and a secure environment, you can rest easy knowing all your needs are met. Located in the heart of Nashville, our residences provide both relaxing surroundings and easy access to city amenities. Choose Woodland Pointe for your next one-bedroom retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Hermitage, TN",
      "seo_description": "Explore one-bedroom apartments at Woodland Pointe in Hermitage, TN. Enjoy modern amenities, spacious layouts, and a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-37214-574",
      "search_query": "two bedroom apartments near 37214",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 37214",
      "h2_subtitle": "Explore two-bedroom apartments near 37214 at Woodland Pointe Residences. Enjoy spacious living and modern amenities in a prime Nashville location.",
      "page_copy": "Discover the perfect two-bedroom apartment near the 37214 area at Woodland Pointe Residences. Our spacious layouts offer generous room sizes and feature gourmet kitchens, designed with modern living in mind. The vaulted ceilings add an elegant touch to your living space, ensuring comfort and style.\n\nWoodland Pointe boasts an array of community amenities including a refreshing pool, inviting picnic areas, and a friendly clubhouse. With professional on-site management and a robust security system in place, residents can enjoy peace of mind. Conveniently located in Nashville, TN, Woodland Pointe is the ideal home for those seeking a vibrant yet comfortable lifestyle near the 37214 zip code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 37214",
      "seo_description": "Find spacious two-bedroom apartments near 37214 at Woodland Pointe Residences. Enjoy modern amenities and a prime Nashville location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-davidson-county-197",
      "search_query": "three bedroom apartments Davidson County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Davidson County",
      "h2_subtitle": "Discover spacious three-bedroom apartments in Davidson County at Woodland Pointe Residences. Enjoy family-friendly living with modern amenities.",
      "page_copy": "At Woodland Pointe Residences, our three-bedroom apartments in Davidson County offer expansive living spaces perfect for families or those needing extra room. These thoughtfully designed homes feature gourmet kitchens, lofty vaulted ceilings, and luxurious outdoor spaces that enhance your living experience.\n\nThe community provides a welcoming atmosphere with amenities such as a relaxing pool, picnic/barbecue areas, and a sociable clubhouse. With on-site management and a dedicated security system, residents enjoy both safety and convenience. Located in Nashville, TN, within Davidson County, Woodland Pointe is ideal for those seeking comfort and contemporary living in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Davidson County",
      "seo_description": "Spacious three-bedroom apartments at Woodland Pointe in Davidson County offer modern living with top amenities in a welcoming Nashville community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "apartments-near-mcgavock-high-school-nashville-21",
      "search_query": "apartments near McGavock High School Nashville",
      "category": "School",
      "h1_title": "Apartments Near McGavock High School",
      "h2_subtitle": "Find ideal apartments near McGavock High School, Nashville at Woodland Pointe Residences. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Woodland Pointe Residences offers convenient and contemporary living with our range of apartments near McGavock High School in Nashville. Choose from spacious one, two, and three-bedroom floor plans that cater to diverse lifestyles. Each apartment boasts modern features like gourmet kitchens and vaulted ceilings that provide both style and comfort.\n\nLocated in vibrant Nashville, our community includes amenities such as a refreshing pool, picnic/barbecue areas, and a clubhouse—perfect for meeting new friends and neighbors. The on-site property management ensures attentive service, enhancing the living experience. Choose Woodland Pointe Residences for comfortable living just a short drive from McGavock High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McGavock High School Nashville",
      "seo_description": "Discover apartments near McGavock High School at Woodland Pointe in Nashville, offering modern amenities and a welcoming community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "rentals-close-to-mcgavock-elementary-school-hermitage-785",
      "search_query": "rentals close to McGavock Elementary School Hermitage",
      "category": "School",
      "h1_title": "Rentals Close to McGavock Elementary School",
      "h2_subtitle": "Explore rentals close to McGavock Elementary School in Hermitage at Woodland Pointe Residences. Enjoy a family-friendly community with top amenities.",
      "page_copy": "Located in Hermitage, Woodland Pointe Residences offers convenient rentals close to McGavock Elementary School. Our one, two, and three-bedroom apartments are designed with families in mind, providing ample space and modern features like gourmet kitchens and vaulted ceilings.\n\nThe community at Woodland Pointe boasts a range of amenities, including a swimming pool, picnic/barbecue areas, and a friendly clubhouse, making it a perfect home base for engaging with neighbors. With professional on-site management, you can enjoy peace of mind and responsive service. Choose Woodland Pointe for comfortable living in proximity to McGavock Elementary School in a welcoming Nashville neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to McGavock Elementary School",
      "seo_description": "Find rentals near McGavock Elementary School at Woodland Pointe Residences in Hermitage, offering spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "nashville-apartments-near-two-rivers-middle-school-468",
      "search_query": "Nashville apartments near Two Rivers Middle School",
      "category": "School",
      "h1_title": "Nashville Apartments Near Two Rivers Middle",
      "h2_subtitle": "Experience superb Nashville apartments near Two Rivers Middle School at Woodland Pointe Residences. Enjoy contemporary features and community amenities.",
      "page_copy": "Woodland Pointe Residences presents exceptional Nashville apartments near Two Rivers Middle School. Choose from our thoughtfully designed one, two, and three-bedroom layouts that promise comfort and style, featuring gourmet kitchens and impressive vaulted ceilings.\n\nOur vibrant community offers a plethora of amenities—including a sparkling pool, picnic/barbecue areas, and a welcoming clubhouse—perfect for enjoying leisure time and fostering community connections. With proactive on-site management, residents benefit from attentive and responsive service. Nestled in the heart of Nashville, Woodland Pointe combines modern living with proximity to Two Rivers Middle School, ensuring a convenient and enriching living experience for families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nashville Apartments Near Two Rivers Middle",
      "seo_description": "Find Nashville apartments close to Two Rivers Middle School at Woodland Pointe, where modern living meets convenience and community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "hermitage-rentals-near-hickman-elementary-school-828",
      "search_query": "Hermitage rentals near Hickman Elementary School",
      "category": "School",
      "h1_title": "Hermitage Rentals Near Hickman Elementary",
      "h2_subtitle": "Find ideal Hermitage rentals near Hickman Elementary School at Woodland Pointe Residences. Enjoy spacious apartments and family-friendly amenities.",
      "page_copy": "Discover Woodland Pointe Residences, offering Hermitage rentals near Hickman Elementary School. Our community features spacious one, two, and three-bedroom apartments that balance luxury and comfort with amenities such as gourmet kitchens and vaulted ceilings.\n\nResidents enjoy access to a range of facilities, from a refreshing pool and scenic picnic/barbecue areas to a cozy clubhouse perfect for community gatherings. The professional on-site management team at Woodland Pointe is always ready to assist, ensuring a smooth and enjoyable living experience. Located in Hermitage, these rentals provide a perfect base for families seeking proximity to Hickman Elementary School amid modern conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hermitage Rentals Near Hickman Elementary School",
      "seo_description": "Explore Hermitage rentals close to Hickman Elementary School at Woodland Pointe, offering family-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "woodland-pointe-apartments-near-stanford-montessori-852",
      "search_query": "Woodland Pointe apartments near Stanford Montessori Elementary",
      "category": "School",
      "h1_title": "Woodland Pointe Near Stanford Montessori",
      "h2_subtitle": "Find Woodland Pointe apartments near Stanford Montessori Elementary. Experience a harmonious blend of luxury and convenience in Nashville.",
      "page_copy": "Woodland Pointe Residences is the perfect choice for those seeking apartments near Stanford Montessori Elementary. Offering expansive one, two, and three-bedroom layouts, our homes are designed with modern sophistication featuring gourmet kitchens and vaulted ceilings that elevate everyday living.\n\nEnjoy a range of community amenities including a sparkling pool, beautifully landscaped picnic/barbecue areas, and a welcoming clubhouse ideal for social gatherings. Our on-site management ensures exceptional service tailored to resident needs. Positioned in Nashville, Woodland Pointe provides a prime location for families looking to reside near Stanford Montessori Elementary while enjoying a superior living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Woodland Pointe Near Stanford Montessori Elementary",
      "seo_description": "Discover Woodland Pointe apartments near Stanford Montessori Elementary, offering a blend of comfort and convenience in Nashville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "nashville-rentals-near-music-city-montessori-702",
      "search_query": "Nashville rentals near Music City Montessori",
      "category": "School",
      "h1_title": "Nashville Rentals Near Music City Montessori",
      "h2_subtitle": "Explore Nashville rentals near Music City Montessori at Woodland Pointe Residences, where comfort meets community living.",
      "page_copy": "Discover unparalleled living at Woodland Pointe Residences, offering Nashville rentals near Music City Montessori. Our thoughtfully designed one, two, and three-bedroom apartments provide a spacious retreat with features like gourmet kitchens and elegant vaulted ceilings.\n\nResidents enjoy a suite of amenities including a refreshing pool, inviting picnic/barbecue areas, and a vibrant clubhouse for gatherings. With our dedicated on-site management team, experience attentive service tailored to your needs. Located in a prime Nashville locale, Woodland Pointe provides families and professionals alike the ideal environment close to Music City Montessori while enjoying superior living features and services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nashville Rentals Near Music City Montessori",
      "seo_description": "Find comfort and convenience with Nashville rentals near Music City Montessori at Woodland Pointe. Enjoy modern amenities and a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "rentals-close-to-holy-rosary-academy-nashville-432",
      "search_query": "rentals close to Holy Rosary Academy Nashville",
      "category": "School",
      "h1_title": "Rentals Near Holy Rosary Academy Nashville",
      "h2_subtitle": "Find rentals close to Holy Rosary Academy in Nashville at Woodland Pointe Residences. Experience optimal living in a welcoming community.",
      "page_copy": "Discover a unique living experience at Woodland Pointe Residences, offering rentals close to Holy Rosary Academy in Nashville. Our one, two, and three-bedroom apartments provide an ideal living environment with luxury touches like gourmet kitchens and vaulted ceilings.\n\nCommunity amenities abound, featuring a refreshing swimming pool, inviting picnic/barbecue spaces, and a clubhouse perfect for relaxation and social interactions. Our attentive on-site management team is here to ensure your comfort and satisfaction. Located conveniently near Holy Rosary Academy, Woodland Pointe offers families and individuals a perfect blend of proximity and upscale living in the heart of Nashville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Holy Rosary Academy Nashville",
      "seo_description": "Explore Woodland Pointe Residences near Holy Rosary Academy, Nashville. Offering modern rentals with premier amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "apartments-near-tristar-summit-medical-center-hermitage-271",
      "search_query": "apartments near TriStar Summit Medical Center Hermitage",
      "category": "Hospital",
      "h1_title": "Apartments Near TriStar Summit Medical Center",
      "h2_subtitle": "Discover comfortable living in apartments near TriStar Summit Medical Center. Woodland Pointe offers ideal accommodations in Hermitage.",
      "page_copy": "Woodland Pointe Residences welcomes you to a premium living experience with apartments near TriStar Summit Medical Center in Hermitage. Our carefully curated one, two, and three-bedroom floor plans feature sophisticated elements like gourmet kitchens and soaring vaulted ceilings, making your living experience both luxurious and practical.\n\nOur community amenities include a serene swimming pool, convenient picnic/barbecue areas, and an engaging clubhouse, providing a delightful environment for relaxation and social gatherings. Managed by a dedicated on-site team, we ensure a seamless living experience tailored to your needs. Located near TriStar Summit Medical Center, Woodland Pointe is perfectly positioned for healthcare professionals and anyone seeking accessible, upscale living in Nashville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near TriStar Summit Medical Center",
      "seo_description": "Find Woodland Pointe Residences, Hermitage, offering modern apartments close to TriStar Summit Medical Center with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "apartments-near-hamilton-creek-recreation-area-tn-453",
      "search_query": "apartments near Hamilton Creek Recreation Area TN",
      "category": "Park",
      "h1_title": "Apartments Near Hamilton Creek Recreation Area",
      "h2_subtitle": "Explore idyllic living near Hamilton Creek Recreation Area with Woodland Pointe. Embrace comfort and convenience in Nashville, TN.",
      "page_copy": "Nestled in the vibrant community of Nashville, Woodland Pointe Residences offers exquisite apartments near Hamilton Creek Recreation Area, TN. Choose from a selection of one, two, or three-bedroom layouts, each featuring expansive designs, gourmet kitchens, and vaulted ceilings that enhance your everyday living experience.\n\nOur community is richly appointed with amenities that cater to both relaxation and recreation. Enjoy a refreshing dip in our pool, host a barbecue in our picnic areas, or unwind with friends in our fully-equipped clubhouse. With its close proximity to Hamilton Creek Recreation Area, Woodland Pointe provides a perfect balance of nature and city life, ideal for those seeking an active and yet tranquil environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hamilton Creek Recreation Area",
      "seo_description": "Discover Woodland Pointe Residences near Hamilton Creek Recreation Area, TN. Ideal living space with modern amenities blending comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "mill-ridge-park-nearby-apartments-hermitage-823",
      "search_query": "Mill Ridge Park nearby apartments Hermitage",
      "category": "Park",
      "h1_title": "Mill Ridge Park Nearby Apartments in Hermitage",
      "h2_subtitle": "Discover Woodland Pointe's nearby apartments in Hermitage, close to Mill Ridge Park. Enjoy a blend of comfort and community living.",
      "page_copy": "Woodland Pointe Residences presents an ideal living solution with nearby apartments in Hermitage, close to the scenic Mill Ridge Park. Our community offers spacious one, two, and three-bedroom apartment homes featuring modern amenities such as gourmet kitchens, vaulted ceilings, and select units with stainless appliances.\n\nResidents can take advantage of our delightful on-site amenities, which include a refreshing pool, engaging clubhouse, and convenient picnic/barbecue areas perfect for gatherings with friends or family. With a dedicated property management team on-site and a robust security system, you can enjoy peace of mind while living close to Mill Ridge Park. Woodland Pointe combines the tranquility of nature with the vibrancy of community life in Nashville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mill Ridge Park Nearby Apartments in Hermitage",
      "seo_description": "Find your home at Woodland Pointe, offering apartments near Mill Ridge Park Hermitage with modern amenities and convenient community features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "davidson-county-apartments-near-una-recreation-park-652",
      "search_query": "Davidson County apartments close to Una Recreation Park",
      "category": "Park",
      "h1_title": "Davidson County Apartments Near Una Recreation Park",
      "h2_subtitle": "Woodland Pointe offers stylish apartments close to Una Recreation Park. Experience community living in Davidson County with premium amenities.",
      "page_copy": "Discover the comfort and convenience of Woodland Pointe Residences, offering premium apartments close to Una Recreation Park in Davidson County. Our selection of spacious one, two, and three-bedroom apartments are perfect for those seeking modern living with features like gourmet kitchens and vaulted ceilings.\n\nAt Woodland Pointe, residents can enjoy a range of amenities tailored to enhance their lifestyle, including a shimmering pool, a welcoming clubhouse, and well-appointed picnic/barbecue areas ideal for relaxation and socializing. With on-site property management and a reliable security system, Woodland Pointe ensures a seamless living experience in the heart of Nashville, just moments away from Una Recreation Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Davidson County Apartments Near Una Recreation Park",
      "seo_description": "Explore Woodland Pointe, Davidson County apartments near Una Recreation Park, featuring spacious designs and excellent community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167503",
      "source": "custom",
      "page_item_url": "apartments-near-nashville-international-airport-309",
      "search_query": "apartments near nashville international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Nashville International Airport",
      "h2_subtitle": "Find convenience at Woodland Pointe, just minutes from Nashville International Airport. Enjoy comfortable living in a vibrant community.",
      "page_copy": "Woodland Pointe Residences provide an ideal location for those seeking apartments near Nashville International Airport. Our one, two, and three-bedroom apartments are thoughtfully designed with modern features like gourmet kitchens and vaulted ceilings, ensuring a comfortable living experience.\n\nResidents can indulge in an array of amenities, including a refreshing pool, a social clubhouse, and inviting picnic/barbecue areas perfect for gatherings. With a security system and on-site property management, Woodland Pointe ensures a hassle-free lifestyle. Whether you're traveling frequently or looking to explore the vibrant city, living near the airport makes life more convenient and enjoyable in Nashville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with plush seating and large windows overlooking the pool and courtyard.",
        "public_id": "019f6c14-56fc-7470-8df5-778f5bfc809b",
        "storage_key": "property/6767906449167503/019f6c14-56fc-7470-8df5-778f5bfc809b.webp",
        "width": 838,
        "height": 471
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Nashville International Airport",
      "seo_description": "Live at Woodland Pointe, conveniently near Nashville International Airport. Enjoy modern amenities and a prime Nashville location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6345"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12021527533"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5669917"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TPM6JFMS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54965251957"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11f138b3117abcd8"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "615-912-1779"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlBmak92QzZ6SEYyUWYyRjBxM0srZmc9PSIsInZhbHVlIjoiKzVYV3JTZWJjQVdZRkFoNGJ6T0ZXZz09IiwibWFjIjoiMzNmNmJiZjUyMWQwMmM2YWY5YTZjNzlmMTVjMjM5YzFhYTc0NTc0NzUyZTA5ODFiMTZkMjkyOTg3OTgzY2Q3YSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "6345",
  "custom_repli_id": "12021527533",
  "custom_realpage_id": "5669917",
  "custom_google_gtm_id": "GTM-TPM6JFMS",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "54965251957",
  "custom_knock_community_id": "11f138b3117abcd8",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "615-912-1779",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlBmak92QzZ6SEYyUWYyRjBxM0srZmc9PSIsInZhbHVlIjoiKzVYV3JTZWJjQVdZRkFoNGJ6T0ZXZz09IiwibWFjIjoiMzNmNmJiZjUyMWQwMmM2YWY5YTZjNzlmMTVjMjM5YzFhYTc0NTc0NzUyZTA5ODFiMTZkMjkyOTg3OTgzY2Q3YSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "94112d0f-aa69-4e50-bf69-d2702652a217",
  "custom_audioeye_site_hash": "2e735c40a90826a64265312e28d846c0"
};

export const generatedAt = '2026-11-03T22:12:35.587Z';
